window.COLOR_TRANSLATIONS = {
  "ABB": "AZUL_(ABB)",
  "ABIN": "AZUL_(ABIN)",
  "ABNB": "AZUL_(ABNB)",
  "ABRG": "VERDE_(ABRG)",
  "ABSB": "AZUL_(ABSB)",
  "ABSG": "AZUL_(ABSG)",
  "ACFO": "AZUL_(ACFO)",
  "ACI": "MORADO_(ACI)",
  "ADAB": "AZUL_(ADAB)",
  "ADCT": "AZUL_(ADCT)",
  "ADZ": "ROJO_(ADZ)",
  "AFNP": "ROSADO_(AFNP)",
  "AGA": "VERDE_(AGA)",
  "AGG": "VERDE_(AGG)",
  "AGL": "ROJO_(AGL)",
  "AGT": "VERDE_(AGT)",
  "AIC": "AZUL_(AIC)",
  "AKU": "AZUL_(AKU)",
  "ALP": "VERDE_(ALP)",
  "ALPB": "AZUL_(ALPB)",
  "AMH": "ROSADO_(AMH)",
  "AMRE": "ROJO_(AMRE)",
  "ANDB": "AZUL_(ANDB)",
  "ANE": "VERDE_(ANE)",
  "ANTP": "ROSADO_(ANTP)",
  "ANVY": "AZUL_(ANVY)",
  "AOG": "VERDE_(AOG)",
  "AON": "CAFE_(AON)",
  "APA": "CAFE_(APA)",
  "APBL": "AZUL_(APBL)",
  "API": "AZUL_(API)",
  "APK": "ROSADO_(APK)",
  "APU": "VERDE_(APU)",
  "AQR": "VERDE_(AQR)",
  "AQST": "VERDE_(AQST)",
  "AQT": "AZUL_(AQT)",
  "ARCM": "VERDE_(ARCM)",
  "ARGR": "VERDE_(ARGR)",
  "ARPI": "ROSADO_(ARPI)",
  "ART": "VERDE_(ART)",
  "ARWD": "ROJO_(ARWD)",
  "ASAT": "NEUTRO_(ASAT)",
  "ASHT": "NEUTRO_(ASHT)",
  "AST": "NEUTRO_(AST)",
  "ATAQ": "VERDE_(ATAQ)",
  "ATBL": "AZUL_(ATBL)",
  "ATDE": "NEUTRO_(ATDE)",
  "ATF": "NARANJO_(ATF)",
  "ATQ": "ROSADO_(ATQ)",
  "ATSA": "NEUTRO_(ATSA)",
  "AUPI": "ROSADO_(AUPI)",
  "AWP": "VERDE_(AWP)",
  "AZT": "AMARILLO_(AZT)",
  "BABN": "CAFE_(BABN)",
  "BABR": "CAFE_(BABR)",
  "BAI": "NEUTRO_(BAI)",
  "BAK": "NEUTRO_(BAK)",
  "BALB": "AZUL_(BALB)",
  "BALG": "AZUL_(BALG)",
  "BAM": "NEUTRO_(BAM)",
  "BAN": "NEGRO_(BAN)",
  "BARR": "ROJO_(BARR)",
  "BBB": "NEGRO_(BBB)",
  "BBCY": "AZUL_(BBCY)",
  "BBE": "AZUL_(BBE)",
  "BBRD": "AZUL_(BBRD)",
  "BBTN": "CAFE_(BBTN)",
  "BBY": "MORADO_(BBY)",
  "BBYB": "NEGRO_(BBYB)",
  "BCG": "NEGRO_(BCG)",
  "BCH": "CAFE_(BCH)",
  "BCNP": "NEGRO_(BCNP)",
  "BCW": "BLANCO_(BCW)",
  "BCWC": "BLANCO_(BCWC)",
  "BDGE": "VERDE_(BDGE)",
  "BDTQ": "AZUL_(BDTQ)",
  "BDX": "ROJO_(BDX)",
  "BEBE": "VERDE_(BEBE)",
  "BEBL": "AZUL_(BEBL)",
  "BEBR": "CAFE_(BEBR)",
  "BECB": "AZUL_(BECB)",
  "BECL": "AZUL_(BECL)",
  "BEFM": "AZUL_(BEFM)",
  "BELW": "NEGRO_(BELW)",
  "BENB": "CAFE_(BENB)",
  "BENE": "CAFE_(BENE)",
  "BEO": "NEGRO_(BEO)",
  "BEOR": "NARANJO_(BEOR)",
  "BEPB": "NEUTRO_(BEPB)",
  "BEPG": "NEUTRO_(BEPG)",
  "BETN": "NEGRO_(BETN)",
  "BEU": "AZUL_(BEU)",
  "BEY": "ROSADO_(BEY)",
  "BFO": "NEGRO_(BFO)",
  "BFZT": "NEGRO_(BFZT)",
  "BGAB": "AZUL_(BGAB)",
  "BGFT": "VERDE_(BGFT)",
  "BGL": "VERDE_(BGL)",
  "BGRN": "VERDE_(BGRN)",
  "BGS": "NEGRO_(BGS)",
  "BHH": "BLANCO_(BHH)",
  "BIBL": "BLANCO_(BIBL)",
  "BIFG": "BLANCO_(BIFG)",
  "BIFL": "BLANCO_(BIFL)",
  "BIKB": "NEGRO_(BIKB)",
  "BIML": "BLANCO_(BIML)",
  "BIO": "NEGRO_(BIO)",
  "BIR": "VERDE_(BIR)",
  "BIU": "AZUL_(BIU)",
  "BIVJ": "BLANCO_(BIVJ)",
  "BKCT": "NEGRO_(BKCT)",
  "BKDG": "NEGRO_(BKDG)",
  "BKEK": "NEGRO_(BKEK)",
  "BKF": "NEGRO_(BKF)",
  "BKFL": "NEGRO_(BKFL)",
  "BKG": "NEGRO_(BKG)",
  "BKGA": "VERDE_(BKGA)",
  "BKGY": "NEGRO_(BKGY)",
  "BKH": "NEGRO_(BKH)",
  "BKPE": "NEGRO_(BKPE)",
  "BKPL": "MORADO_(BKPL)",
  "BKRB": "NEGRO_(BKRB)",
  "BKRR": "NEGRO_(BKRR)",
  "BKSO": "NEGRO_(BKSO)",
  "BKWG": "AMARILLO_(BKWG)",
  "BKY": "VERDE_(BKY)",
  "BLAL": "NEGRO_(BLAL)",
  "BLAM": "NEGRO_(BLAM)",
  "BLB": "NEGRO_(BLB)",
  "BLBN": "NEGRO_(BLBN)",
  "BLBU": "NEGRO_(BLBU)",
  "BLC": "AZUL_(BLC)",
  "BLCW": "NEGRO_(BLCW)",
  "BLE": "AZUL_(BLE)",
  "BLH": "AZUL_(BLH)",
  "BLK": "NEGRO_(BLK)",
  "BLKA": "NEGRO_(BLKA)",
  "BLKP": "NEGRO_(BLKP)",
  "BLL": "AZUL_(BLL)",
  "BLMG": "VERDE_(BLMG)",
  "BLN": "VERDE_(BLN)",
  "BLPA": "NEUTRO_(BLPA)",
  "BLR": "CAFE_(BLR)",
  "BLRE": "NEGRO_(BLRE)",
  "BLSM": "NEGRO_(BLSM)",
  "BLST": "NEUTRO_(BLST)",
  "BLYB": "AZUL_(BLYB)",
  "BLZY": "AMARILLO_(BLZY)",
  "BMY": "CAFE_(BMY)",
  "BNDB": "AZUL_(BNDB)",
  "BNFG": "AZUL_(BNFG)",
  "BNGD": "AMARILLO_(BNGD)",
  "BNLB": "AZUL_(BNLB)",
  "BNLG": "VERDE_(BNLG)",
  "BNVU": "NEGRO_(BNVU)",
  "BNZ": "CAFE_(BNZ)",
  "BOB": "NEGRO_(BOB)",
  "BOK": "CAFE_(BOK)",
  "BON": "NARANJO_(BON)",
  "BPU": "NEGRO_(BPU)",
  "BPYK": "NEGRO_(BPYK)",
  "BRAR": "NEGRO_(BRAR)",
  "BRBL": "AZUL_(BRBL)",
  "BRBN": "CAFE_(BRBN)",
  "BRLG": "VERDE_(BRLG)",
  "BRNE": "ROJO_(BRNE)",
  "BRTA": "NEUTRO_(BRTA)",
  "BRYG": "VERDE_(BRYG)",
  "BSA": "VERDE_(BSA)",
  "BSBA": "AZUL_(BSBA)",
  "BSBL": "AZUL_(BSBL)",
  "BSBU": "AZUL_(BSBU)",
  "BSCV": "AZUL_(BSCV)",
  "BSDO": "NEUTRO_(BSDO)",
  "BSEK": "NEUTRO_(BSEK)",
  "BSFE": "AZUL_(BSFE)",
  "BSMB": "NEGRO_(BSMB)",
  "BSNG": "VERDE_(BSNG)",
  "BSNY": "AZUL_(BSNY)",
  "BSRB": "AZUL_(BSRB)",
  "BSTA": "NEUTRO_(BSTA)",
  "BTBR": "CAFE_(BTBR)",
  "BTEI": "NEGRO_(BTEI)",
  "BTGN": "VERDE_(BTGN)",
  "BTLG": "NEGRO_(BTLG)",
  "BTRY": "AMARILLO_(BTRY)",
  "BTY": "AZUL_(BTY)",
  "BUBR": "CAFE_(BUBR)",
  "BUE": "ROSADO_(BUE)",
  "BUEB": "AZUL_(BUEB)",
  "BUFG": "VERDE_(BUFG)",
  "BUG": "AZUL_(BUG)",
  "BUGR": "VERDE_(BUGR)",
  "BUPB": "AZUL_(BUPB)",
  "BUR": "NEUTRO_(BUR)",
  "BURD": "ROJO_(BURD)",
  "BURR": "ROJO_(BURR)",
  "BUTA": "AZUL_(BUTA)",
  "BVKB": "NEGRO_(BVKB)",
  "BVTB": "AZUL_(BVTB)",
  "BWBA": "BLANCO_(BWBA)",
  "BWBE": "BLANCO_(BWBE)",
  "BWCB": "BLANCO_(BWCB)",
  "BWEK": "CAFE_(BWEK)",
  "BWEP": "BLANCO_(BWEP)",
  "BWG": "AZUL_(BWG)",
  "BWH": "NEGRO_(BWH)",
  "BWIM": "BLANCO_(BWIM)",
  "BWPI": "BLANCO_(BWPI)",
  "BWRY": "BLANCO_(BWRY)",
  "BWTI": "BLANCO_(BWTI)",
  "BWW": "NEGRO_(BWW)",
  "BWX": "AMARILLO_(BWX)",
  "BYBL": "AZUL_(BYBL)",
  "BYBU": "AZUL_(BYBU)",
  "BYED": "AZUL_(BYED)",
  "BYFT": "AZUL_(BYFT)",
  "BYO": "AZUL_(BYO)",
  "BYTB": "AZUL_(BYTB)",
  "BYTN": "AZUL_(BYTN)",
  "BYY": "ROJO_(BYY)",
  "CABK": "VERDE_(CABK)",
  "CACL": "AZUL_(CACL)",
  "CACN": "NEGRO_(CACN)",
  "CACO": "ROJO_(CACO)",
  "CADB": "AZUL_(CADB)",
  "CAGO": "AMARILLO_(CAGO)",
  "CAGR": "GRIS_(CAGR)",
  "CALC": "BLANCO_(CALC)",
  "CAN": "NEGRO_(CAN)",
  "CARG": "VERDE_(CARG)",
  "CASG": "VERDE_(CASG)",
  "CAT": "CAFE_(CAT)",
  "CAWH": "AZUL_(CAWH)",
  "CBCA": "AZUL_(CBCA)",
  "CBCU": "AZUL_(CBCU)",
  "CBE": "AZUL_(CBE)",
  "CBF": "AZUL_(CBF)",
  "CBRS": "CAFE_(CBRS)",
  "CBS": "ROSADO_(CBS)",
  "CBTB": "AZUL_(CBTB)",
  "CBY": "ROJO_(CBY)",
  "CCRL": "ROJO_(CCRL)",
  "CDD": "ROJO_(CDD)",
  "CDM": "CAFE_(CDM)",
  "CDRR": "ROJO_(CDRR)",
  "CED": "CAFE_(CED)",
  "CELA": "VERDE_(CELA)",
  "CELG": "VERDE_(CELG)",
  "CEM": "NARANJO_(CEM)",
  "CEO": "ROSADO_(CEO)",
  "CEP": "ROSADO_(CEP)",
  "CET": "ROJO_(CET)",
  "CEY": "AZUL_(CEY)",
  "CFTP": "ROSADO_(CFTP)",
  "CFTR": "VERDE_(CFTR)",
  "CGLD": "AMARILLO_(CGLD)",
  "CGNC": "VERDE_(CGNC)",
  "CHB": "AZUL_(CHB)",
  "CHIR": "ROJO_(CHIR)",
  "CHL": "CAFE_(CHL)",
  "CHLE": "AZUL_(CHLE)",
  "CHR": "GRIS_(CHR)",
  "CHRT": "VERDE_(CHRT)",
  "CIE": "ROJO_(CIE)",
  "CIFG": "VERDE_(CIFG)",
  "CIGB": "AZUL_(CIGB)",
  "CINV": "ROJO_(CINV)",
  "CIR": "VERDE_(CIR)",
  "CLCA": "AZUL_(CLCA)",
  "CLDO": "AZUL_(CLDO)",
  "CLH": "GRIS_(CLH)",
  "CLI": "AMARILLO_(CLI)",
  "CLL": "AZUL_(CLL)",
  "CLMB": "AZUL_(CLMB)",
  "CLOO": "NARANJO_(CLOO)",
  "CLOR": "NARANJO_(CLOR)",
  "CLR": "NEUTRO_(CLR)",
  "CLRM": "ROSADO_(CLRM)",
  "CLS": "AZUL_(CLS)",
  "CML": "CAFE_(CML)",
  "CMLW": "BLANCO_(CMLW)",
  "CMN": "NARANJO_(CMN)",
  "CMPG": "VERDE_(CMPG)",
  "CMPO": "NARANJO_(CMPO)",
  "CMYG": "VERDE_(CMYG)",
  "CNB": "AZUL_(CNB)",
  "CNBA": "AZUL_(CNBA)",
  "CNBB": "AZUL_(CNBB)",
  "CNBR": "CAFE_(CNBR)",
  "CNCP": "MORADO_(CNCP)",
  "CNCR": "AZUL_(CNCR)",
  "CNGB": "AZUL_(CNGB)",
  "CNKH": "AZUL_(CNKH)",
  "CNME": "AZUL_(CNME)",
  "CNMO": "AZUL_(CNMO)",
  "CNPL": "MORADO_(CNPL)",
  "CNR": "AMARILLO_(CNR)",
  "CNT": "ROJO_(CNT)",
  "CNTT": "AZUL_(CNTT)",
  "CNWB": "AZUL_(CNWB)",
  "CNY": "AZUL_(CNY)",
  "CNYT": "AZUL_(CNYT)",
  "COB": "AZUL_(COB)",
  "COCR": "ROJO_(COCR)",
  "COFP": "ROSADO_(COFP)",
  "COHC": "ROSADO_(COHC)",
  "COI": "CAFE_(COI)",
  "CON": "CAFE_(CON)",
  "COR": "ROSADO_(COR)",
  "CORG": "GRIS_(CORG)",
  "COWP": "NARANJO_(COWP)",
  "COY": "CAFE_(COY)",
  "COZP": "NARANJO_(COZP)",
  "CPCN": "ROSADO_(CPCN)",
  "CPCP": "ROSADO_(CPCP)",
  "CPK": "ROSADO_(CPK)",
  "CPLG": "VERDE_(CPLG)",
  "CPNG": "GRIS_(CPNG)",
  "CPO": "AZUL_(CPO)",
  "CPOR": "NARANJO_(CPOR)",
  "CPPK": "ROSADO_(CPPK)",
  "CPRG": "VERDE_(CPRG)",
  "CPSU": "ROSADO_(CPSU)",
  "CRBA": "AZUL_(CRBA)",
  "CRDI": "AZUL_(CRDI)",
  "CRGN": "VERDE_(CRGN)",
  "CRGY": "GRIS_(CRGY)",
  "CRI": "ROJO_(CRI)",
  "CRK": "NEUTRO_(CRK)",
  "CRMD": "ROJO_(CRMD)",
  "CRMP": "ROSADO_(CRMP)",
  "CRNV": "ROJO_(CRNV)",
  "CROE": "ROJO_(CROE)",
  "CRVC": "ROSADO_(CRVC)",
  "CSC": "NEUTRO_(CSC)",
  "CSH": "NEUTRO_(CSH)",
  "CSMD": "AMARILLO_(CSMD)",
  "CSRD": "ROJO_(CSRD)",
  "CSTY": "AMARILLO_(CSTY)",
  "CSV": "AZUL_(CSV)",
  "CSY": "AZUL_(CSY)",
  "CTF": "VERDE_(CTF)",
  "CTN": "AZUL_(CTN)",
  "CTR": "AMARILLO_(CTR)",
  "CTRB": "AZUL_(CTRB)",
  "CTSB": "CAFE_(CTSB)",
  "CTYB": "AZUL_(CTYB)",
  "CTYR": "ROJO_(CTYR)",
  "CUA": "AZUL_(CUA)",
  "CUBB": "AZUL_(CUBB)",
  "CUBL": "AZUL_(CUBL)",
  "CUE": "AZUL_(CUE)",
  "CUR": "AZUL_(CUR)",
  "CUSO": "NARANJO_(CUSO)",
  "CVK": "AZUL_(CVK)",
  "CVP": "AZUL_(CVP)",
  "CVSB": "AZUL_(CVSB)",
  "CYL": "AMARILLO_(CYL)",
  "CYNB": "CAFE_(CYNB)",
  "CYW": "CAFE_(CYW)",
  "DABL": "AZUL_(DABL)",
  "DAK": "ROJO_(DAK)",
  "DAP": "NARANJO_(DAP)",
  "DAPL": "NEUTRO_(DAPL)",
  "DARU": "ROJO_(DARU)",
  "DASG": "VERDE_(DASG)",
  "DBGR": "VERDE_(DBGR)",
  "DCBN": "GRIS_(DCBN)",
  "DCE": "VERDE_(DCE)",
  "DCOI": "GRIS_(DCOI)",
  "DDNM": "AZUL_(DDNM)",
  "DDRB": "GRIS_(DDRB)",
  "DEE": "AZUL_(DEE)",
  "DESO": "NARANJO_(DESO)",
  "DET": "VERDE_(DET)",
  "DFSM": "GRIS_(DFSM)",
  "DFTB": "GRIS_(DFTB)",
  "DFTD": "GRIS_(DFTD)",
  "DFTG": "GRIS_(DFTG)",
  "DGBE": "GRIS_(DGBE)",
  "DGDB": "GRIS_(DGDB)",
  "DGDP": "MORADO_(DGDP)",
  "DGF": "ROSADO_(DGF)",
  "DGMG": "GRIS_(DGMG)",
  "DGPP": "GRIS_(DGPP)",
  "DGPU": "GRIS_(DGPU)",
  "DGRE": "GRIS_(DGRE)",
  "DGRI": "GRIS_(DGRI)",
  "DGSK": "GRIS_(DGSK)",
  "DGSP": "GRIS_(DGSP)",
  "DGWB": "GRIS_(DGWB)",
  "DGWI": "GRIS_(DGWI)",
  "DIL": "VERDE_(DIL)",
  "DIND": "GRIS_(DIND)",
  "DKAS": "CAFE_(DKAS)",
  "DKB": "AZUL_(DKB)",
  "DKCA": "CAFE_(DKCA)",
  "DKCT": "ROJO_(DKCT)",
  "DKW": "AZUL_(DKW)",
  "DLA": "AZUL_(DLA)",
  "DLMA": "MORADO_(DLMA)",
  "DLMB": "AZUL_(DLMB)",
  "DMGO": "NARANJO_(DMGO)",
  "DMO": "NARANJO_(DMO)",
  "DNAN": "NEUTRO_(DNAN)",
  "DNAT": "NEUTRO_(DNAT)",
  "DNBA": "NEUTRO_(DNBA)",
  "DNLA": "NEUTRO_(DNLA)",
  "DNLB": "NEUTRO_(DNLB)",
  "DNLG": "NEUTRO_(DNLG)",
  "DNLP": "NEUTRO_(DNLP)",
  "DNLU": "AZUL_(DNLU)",
  "DNPG": "NEUTRO_(DNPG)",
  "DNPI": "VERDE_(DNPI)",
  "DNRL": "NEUTRO_(DNRL)",
  "DNSC": "NEUTRO_(DNSC)",
  "DNSQ": "NEUTRO_(DNSQ)",
  "DOLG": "AZUL_(DOLG)",
  "DPM": "MORADO_(DPM)",
  "DPMH": "MORADO_(DPMH)",
  "DPR": "MORADO_(DPR)",
  "DRBN": "CAFE_(DRBN)",
  "DRDB": "GRIS_(DRDB)",
  "DRF": "NEUTRO_(DRF)",
  "DRGP": "MORADO_(DRGP)",
  "DRIQ": "GRIS_(DRIQ)",
  "DRMF": "ROJO_(DRMF)",
  "DRT": "CAFE_(DRT)",
  "DSC": "NARANJO_(DSC)",
  "DSE": "AZUL_(DSE)",
  "DSTB": "GRIS_(DSTB)",
  "DSTQ": "AZUL_(DSTQ)",
  "DTEW": "GRIS_(DTEW)",
  "DTFG": "GRIS_(DTFG)",
  "DTLG": "VERDE_(DTLG)",
  "DTSG": "VERDE_(DTSG)",
  "DUBN": "CAFE_(DUBN)",
  "DVL": "CAFE_(DVL)",
  "DWA": "CAFE_(DWA)",
  "DWGE": "BLANCO_(DWGE)",
  "DWHP": "BLANCO_(DWHP)",
  "DWP": "AZUL_(DWP)",
  "DWPI": "BLANCO_(DWPI)",
  "DWT": "AZUL_(DWT)",
  "DWV": "CAFE_(DWV)",
  "DYWH": "BLANCO_(DYWH)",
  "ECDB": "CAFE_(ECDB)",
  "ECEB": "CAFE_(ECEB)",
  "ECIG": "VERDE_(ECIG)",
  "ECMK": "NEUTRO_(ECMK)",
  "ECPU": "MORADO_(ECPU)",
  "ECRU": "NEUTRO_(ECRU)",
  "ECSB": "AZUL_(ECSB)",
  "ECTB": "AZUL_(ECTB)",
  "EDBL": "AZUL_(EDBL)",
  "EELG": "VERDE_(EELG)",
  "EGE": "VERDE_(EGE)",
  "EKCA": "NEUTRO_(EKCA)",
  "EKEK": "NEUTRO_(EKEK)",
  "EKGB": "NEUTRO_(EKGB)",
  "EKSB": "NEUTRO_(EKSB)",
  "EKSI": "NEUTRO_(EKSI)",
  "EKST": "NEUTRO_(EKST)",
  "ELGR": "VERDE_(ELGR)",
  "ELKH": "NEUTRO_(ELKH)",
  "ELNB": "AZUL_(ELNB)",
  "ELWB": "AZUL_(ELWB)",
  "ELYT": "VERDE_(ELYT)",
  "EMRD": "VERDE_(EMRD)",
  "ENLB": "AZUL_(ENLB)",
  "ENV": "VERDE_(ENV)",
  "EPCB": "AZUL_(EPCB)",
  "EPGR": "NEUTRO_(EPGR)",
  "ERT": "CAFE_(ERT)",
  "ESB": "AZUL_(ESB)",
  "ESP": "CAFE_(ESP)",
  "ETO": "NARANJO_(ETO)",
  "EVMA": "MORADO_(EVMA)",
  "EWBN": "CAFE_(EWBN)",
  "EYL": "AMARILLO_(EYL)",
  "FBG": "VERDE_(FBG)",
  "FBK": "GRIS_(FBK)",
  "FBNY": "AZUL_(FBNY)",
  "FCH": "GRIS_(FCH)",
  "FCL": "VERDE_(FCL)",
  "FCLR": "GRIS_(FCLR)",
  "FCNY": "GRIS_(FCNY)",
  "FDT": "GRIS_(FDT)",
  "FDUS": "ROSADO_(FDUS)",
  "FEA": "GRIS_(FEA)",
  "FEAB": "GRIS_(FEAB)",
  "FEAC": "GRIS_(FEAC)",
  "FEAP": "ROSADO_(FEAP)",
  "FEB": "AZUL_(FEB)",
  "FEBA": "GRIS_(FEBA)",
  "FEBN": "CAFE_(FEBN)",
  "FECO": "GRIS_(FECO)",
  "FECR": "GRIS_(FECR)",
  "FEDE": "GRIS_(FEDE)",
  "FEG": "GRIS_(FEG)",
  "FEGB": "GRIS_(FEGB)",
  "FEGH": "GRIS_(FEGH)",
  "FEGM": "GRIS_(FEGM)",
  "FEGY": "GRIS_(FEGY)",
  "FEJB": "GRIS_(FEJB)",
  "FEKF": "GRIS_(FEKF)",
  "FEMA": "GRIS_(FEMA)",
  "FEN": "CAFE_(FEN)",
  "FERA": "AZUL_(FERA)",
  "FEW": "GRIS_(FEW)",
  "FFFE": "GRIS_(FFFE)",
  "FFG": "GRIS_(FFG)",
  "FGAT": "VERDE_(FGAT)",
  "FGB": "GRIS_(FGB)",
  "FGBA": "GRIS_(FGBA)",
  "FGBB": "GRIS_(FGBB)",
  "FGBR": "GRIS_(FGBR)",
  "FGBS": "GRIS_(FGBS)",
  "FGCN": "GRIS_(FGCN)",
  "FGCO": "GRIS_(FGCO)",
  "FGCR": "GRIS_(FGCR)",
  "FGCY": "GRIS_(FGCY)",
  "FGDB": "GRIS_(FGDB)",
  "FGE": "GRIS_(FGE)",
  "FGED": "GRIS_(FGED)",
  "FGEK": "GRIS_(FGEK)",
  "FGEL": "AZUL_(FGEL)",
  "FGEN": "GRIS_(FGEN)",
  "FGFF": "GRIS_(FGFF)",
  "FGFR": "GRIS_(FGFR)",
  "FGG": "GRIS_(FGG)",
  "FGGR": "GRIS_(FGGR)",
  "FGIB": "GRIS_(FGIB)",
  "FGLP": "MORADO_(FGLP)",
  "FGMD": "GRIS_(FGMD)",
  "FGMO": "GRIS_(FGMO)",
  "FGN": "VERDE_(FGN)",
  "FGNB": "GRIS_(FGNB)",
  "FGNY": "GRIS_(FGNY)",
  "FGPB": "GRIS_(FGPB)",
  "FGPM": "GRIS_(FGPM)",
  "FGPS": "GRIS_(FGPS)",
  "FGRM": "GRIS_(FGRM)",
  "FGRY": "GRIS_(FGRY)",
  "FGSB": "GRIS_(FGSB)",
  "FGSP": "GRIS_(FGSP)",
  "FGT": "GRIS_(FGT)",
  "FGTA": "GRIS_(FGTA)",
  "FGTN": "GRIS_(FGTN)",
  "FGTP": "GRIS_(FGTP)",
  "FGVK": "GRIS_(FGVK)",
  "FGVP": "GRIS_(FGVP)",
  "FHNY": "AZUL_(FHNY)",
  "FIBU": "ROJO_(FIBU)",
  "FICN": "ROJO_(FICN)",
  "FIFG": "ROJO_(FIFG)",
  "FINB": "AZUL_(FINB)",
  "FKP": "MORADO_(FKP)",
  "FLBL": "AZUL_(FLBL)",
  "FLGN": "VERDE_(FLGN)",
  "FLGR": "VERDE_(FLGR)",
  "FLKB": "AZUL_(FLKB)",
  "FLMP": "ROSADO_(FLMP)",
  "FLN": "GRIS_(FLN)",
  "FLPI": "ROSADO_(FLPI)",
  "FLTB": "AZUL_(FLTB)",
  "FNDG": "VERDE_(FNDG)",
  "FNL": "VERDE_(FNL)",
  "FOB": "GRIS_(FOB)",
  "FODG": "GRIS_(FODG)",
  "FOG": "GRIS_(FOG)",
  "FON": "NARANJO_(FON)",
  "FOR": "VERDE_(FOR)",
  "FORT": "GRIS_(FORT)",
  "FOU": "GRIS_(FOU)",
  "FPK": "ROSADO_(FPK)",
  "FPPM": "ROSADO_(FPPM)",
  "FRDG": "GRIS_(FRDG)",
  "FRDM": "GRIS_(FRDM)",
  "FRE": "ROJO_(FRE)",
  "FRF": "ROJO_(FRF)",
  "FRMB": "ROJO_(FRMB)",
  "FRMG": "GRIS_(FRMG)",
  "FRNE": "ROJO_(FRNE)",
  "FRNV": "GRIS_(FRNV)",
  "FROD": "ROJO_(FROD)",
  "FRR": "ROJO_(FRR)",
  "FRSB": "ROJO_(FRSB)",
  "FRTB": "AZUL_(FRTB)",
  "FRTL": "VERDE_(FRTL)",
  "FRYT": "CAFE_(FRYT)",
  "FTBB": "VERDE_(FTBB)",
  "FTEK": "GRIS_(FTEK)",
  "FTFG": "GRIS_(FTFG)",
  "FTGF": "VERDE_(FTGF)",
  "FTGN": "VERDE_(FTGN)",
  "FTHG": "GRIS_(FTHG)",
  "FTLP": "GRIS_(FTLP)",
  "FTY": "GRIS_(FTY)",
  "FUTB": "AZUL_(FUTB)",
  "FUZM": "NEUTRO_(FUZM)",
  "FVIK": "AZUL_(FVIK)",
  "FWG": "GRIS_(FWG)",
  "FXRE": "ROJO_(FXRE)",
  "FYBB": "GRIS_(FYBB)",
  "FYCT": "GRIS_(FYCT)",
  "FYF": "GRIS_(FYF)",
  "FYGL": "GRIS_(FYGL)",
  "FYL": "CAFE_(FYL)",
  "FYS": "GRIS_(FYS)",
  "GAR": "ROJO_(GAR)",
  "GBNV": "AZUL_(GBNV)",
  "GCB": "AZUL_(GCB)",
  "GCNO": "CAFE_(GCNO)",
  "GCYT": "AZUL_(GCYT)",
  "GDM": "GRIS_(GDM)",
  "GDNG": "VERDE_(GDNG)",
  "GEM": "NARANJO_(GEM)",
  "GEMG": "VERDE_(GEMG)",
  "GEOP": "MORADO_(GEOP)",
  "GGN": "VERDE_(GGN)",
  "GGPE": "CAFE_(GGPE)",
  "GHB": "GRIS_(GHB)",
  "GHBL": "GRIS_(GHBL)",
  "GHMO": "GRIS_(GHMO)",
  "GHPU": "MORADO_(GHPU)",
  "GHRF": "GRIS_(GHRF)",
  "GHSC": "GRIS_(GHSC)",
  "GHSN": "GRIS_(GHSN)",
  "GHWD": "GRIS_(GHWD)",
  "GHWH": "GRIS_(GHWH)",
  "GIN": "ROJO_(GIN)",
  "GJB": "ROJO_(GJB)",
  "GJG": "CAFE_(GJG)",
  "GKG": "VERDE_(GKG)",
  "GKO": "VERDE_(GKO)",
  "GLDA": "NARANJO_(GLDA)",
  "GLDG": "VERDE_(GLDG)",
  "GLGN": "VERDE_(GLGN)",
  "GLGR": "VERDE_(GLGR)",
  "GLH": "GRIS_(GLH)",
  "GLHG": "VERDE_(GLHG)",
  "GLPU": "MORADO_(GLPU)",
  "GLSB": "AZUL_(GLSB)",
  "GMP": "NARANJO_(GMP)",
  "GNCA": "CAFE_(GNCA)",
  "GNGB": "ROSADO_(GNGB)",
  "GNH": "VERDE_(GNH)",
  "GNL": "AZUL_(GNL)",
  "GNO": "VERDE_(GNO)",
  "GNP": "AMARILLO_(GNP)",
  "GNVG": "VERDE_(GNVG)",
  "GNY": "AZUL_(GNY)",
  "GOB": "CAFE_(GOB)",
  "GORG": "VERDE_(GORG)",
  "GPGO": "CAFE_(GPGO)",
  "GPW": "MORADO_(GPW)",
  "GRBN": "CAFE_(GRBN)",
  "GRD": "AMARILLO_(GRD)",
  "GRGR": "VERDE_(GRGR)",
  "GRPG": "VERDE_(GRPG)",
  "GRS": "VERDE_(GRS)",
  "GRV": "GRIS_(GRV)",
  "GRZG": "VERDE_(GRZG)",
  "GSFG": "AZUL_(GSFG)",
  "GSRB": "AZUL_(GSRB)",
  "GSS": "VERDE_(GSS)",
  "GTRN": "VERDE_(GTRN)",
  "GTRP": "AZUL_(GTRP)",
  "GUL": "GRIS_(GUL)",
  "GVAG": "GRIS_(GVAG)",
  "GVGB": "AZUL_(GVGB)",
  "GYPB": "VERDE_(GYPB)",
  "GYPG": "VERDE_(GYPG)",
  "GZG": "VERDE_(GZG)",
  "HABL": "AZUL_(HABL)",
  "HAGL": "AMARILLO_(HAGL)",
  "HAGO": "CAFE_(HAGO)",
  "HARO": "NARANJO_(HARO)",
  "HART": "CAFE_(HART)",
  "HAZP": "MORADO_(HAZP)",
  "HEF": "CAFE_(HEF)",
  "HEN": "CAFE_(HEN)",
  "HENB": "CAFE_(HENB)",
  "HERG": "GRIS_(HERG)",
  "HEXG": "GRIS_(HEXG)",
  "HGFY": "GRIS_(HGFY)",
  "HGR": "GRIS_(HGR)",
  "HIGR": "VERDE_(HIGR)",
  "HKW": "CAFE_(HKW)",
  "HKY": "CAFE_(HKY)",
  "HLMP": "NARANJO_(HLMP)",
  "HMB": "AZUL_(HMB)",
  "HMKG": "VERDE_(HMKG)",
  "HMW": "BLANCO_(HMW)",
  "HNT": "VERDE_(HNT)",
  "HOSD": "AZUL_(HOSD)",
  "HRG": "VERDE_(HRG)",
  "HTE": "ROJO_(HTE)",
  "HTFR": "GRIS_(HTFR)",
  "HTLG": "VERDE_(HTLG)",
  "HUTA": "NEUTRO_(HUTA)",
  "HWLT": "AZUL_(HWLT)",
  "HYD": "MORADO_(HYD)",
  "HYDG": "VERDE_(HYDG)",
  "HYHG": "GRIS_(HYHG)",
  "HYSP": "MORADO_(HYSP)",
  "HYW": "AMARILLO_(HYW)",
  "IBAC": "NEGRO_(IBAC)",
  "IBOG": "NEGRO_(IBOG)",
  "ICEB": "AZUL_(ICEB)",
  "IDIG": "VERDE_(IDIG)",
  "IDSC": "VERDE_(IDSC)",
  "IDYP": "ROSADO_(IDYP)",
  "IFI": "AZUL_(IFI)",
  "IGBL": "AZUL_(IGBL)",
  "IGCA": "VERDE_(IGCA)",
  "IGCO": "VERDE_(IGCO)",
  "IGCT": "VERDE_(IGCT)",
  "IGFG": "VERDE_(IGFG)",
  "IGRK": "VERDE_(IGRK)",
  "IKBB": "NEGRO_(IKBB)",
  "IKP": "MORADO_(IKP)",
  "IMB": "AZUL_(IMB)",
  "IMPG": "VERDE_(IMPG)",
  "INBK": "NEGRO_(INBK)",
  "INC": "NARANJO_(INC)",
  "INDG": "VERDE_(INDG)",
  "INFE": "NEGRO_(INFE)",
  "IONB": "AZUL_(IONB)",
  "IPST": "MORADO_(IPST)",
  "ISLY": "AMARILLO_(ISLY)",
  "IYGL": "ROSADO_(IYGL)",
  "JELY": "AMARILLO_(JELY)",
  "JJA": "VERDE_(JJA)",
  "JND": "VERDE_(JND)",
  "JOBL": "AZUL_(JOBL)",
  "JPR": "VERDE_(JPR)",
  "JVBR": "CAFE_(JVBR)",
  "JWB": "ROSADO_(JWB)",
  "KAGR": "VERDE_(KAGR)",
  "KAHI": "CAFE_(KAHI)",
  "KASB": "CAFE_(KASB)",
  "KESG": "VERDE_(KESG)",
  "KHA": "NEUTRO_(KHA)",
  "KIGO": "AZUL_(KIGO)",
  "KINL": "NEUTRO_(KINL)",
  "KIPI": "ROSADO_(KIPI)",
  "KPF": "VERDE_(KPF)",
  "KSPG": "VERDE_(KSPG)",
  "KUG": "VERDE_(KUG)",
  "KYD": "VERDE_(KYD)",
  "LABL": "AZUL_(LABL)",
  "LAG": "AZUL_(LAG)",
  "LAGB": "AZUL_(LAGB)",
  "LAPN": "AZUL_(LAPN)",
  "LBA": "AZUL_(LBA)",
  "LBOG": "VERDE_(LBOG)",
  "LBSQ": "MORADO_(LBSQ)",
  "LBYG": "VERDE_(LBYG)",
  "LBZY": "AMARILLO_(LBZY)",
  "LCSO": "NARANJO_(LCSO)",
  "LCUB": "AZUL_(LCUB)",
  "LDBR": "CAFE_(LDBR)",
  "LDFE": "VERDE_(LDFE)",
  "LDSG": "VERDE_(LDSG)",
  "LECB": "AZUL_(LECB)",
  "LEDB": "AZUL_(LEDB)",
  "LEF": "VERDE_(LEF)",
  "LEK": "VERDE_(LEK)",
  "LFEA": "GRIS_(LFEA)",
  "LGDG": "VERDE_(LGDG)",
  "LGF": "ROJO_(LGF)",
  "LGS": "VERDE_(LGS)",
  "LIBU": "AZUL_(LIBU)",
  "LIH": "MORADO_(LIH)",
  "LIL": "MORADO_(LIL)",
  "LIP": "ROSADO_(LIP)",
  "LIT": "ROSADO_(LIT)",
  "LLV": "VERDE_(LLV)",
  "LMA": "CAFE_(LMA)",
  "LMBE": "AZUL_(LMBE)",
  "LMGN": "VERDE_(LMGN)",
  "LML": "VERDE_(LML)",
  "LMSP": "ROSADO_(LMSP)",
  "LMST": "AMARILLO_(LMST)",
  "LNB": "AMARILLO_(LNB)",
  "LNGR": "VERDE_(LNGR)",
  "LNS": "CAFE_(LNS)",
  "LPES": "NARANJO_(LPES)",
  "LPT": "AZUL_(LPT)",
  "LPYP": "MORADO_(LPYP)",
  "LQA": "VERDE_(LQA)",
  "LQS": "AMARILLO_(LQS)",
  "LRM": "AZUL_(LRM)",
  "LRW": "GRIS_(LRW)",
  "LSPK": "ROSADO_(LSPK)",
  "LTE": "CAFE_(LTE)",
  "LTF": "ROSADO_(LTF)",
  "LTG": "VERDE_(LTG)",
  "LTPG": "GRIS_(LTPG)",
  "LTSM": "NEUTRO_(LTSM)",
  "LUNP": "MORADO_(LUNP)",
  "LUP": "MORADO_(LUP)",
  "LVBL": "AZUL_(LVBL)",
  "LVT": "MORADO_(LVT)",
  "MAB": "AZUL_(MAB)",
  "MABL": "AZUL_(MABL)",
  "MACH": "VERDE_(MACH)",
  "MADR": "ROJO_(MADR)",
  "MAG": "MORADO_(MAG)",
  "MAGP": "ROSADO_(MAGP)",
  "MAN": "NARANJO_(MAN)",
  "MANR": "ROJO_(MANR)",
  "MAPI": "ROSADO_(MAPI)",
  "MAR": "AZUL_(MAR)",
  "MARG": "NARANJO_(MARG)",
  "MARR": "ROJO_(MARR)",
  "MBPI": "ROSADO_(MBPI)",
  "MCKP": "MORADO_(MCKP)",
  "MDG": "GRIS_(MDG)",
  "MDN": "AZUL_(MDN)",
  "MDX": "CAFE_(MDX)",
  "MEBN": "CAFE_(MEBN)",
  "MED": "VERDE_(MED)",
  "MEMN": "NARANJO_(MEMN)",
  "MEOR": "NARANJO_(MEOR)",
  "MEV": "ROJO_(MEV)",
  "MGLB": "AZUL_(MGLB)",
  "MGO": "NARANJO_(MGO)",
  "MICB": "CAFE_(MICB)",
  "MICG": "VERDE_(MICG)",
  "MID": "AZUL_(MID)",
  "MILY": "AMARILLO_(MILY)",
  "MIO": "CAFE_(MIO)",
  "MJVK": "NEUTRO_(MJVK)",
  "MKCA": "NEUTRO_(MKCA)",
  "MKMO": "NEUTRO_(MKMO)",
  "MLBN": "CAFE_(MLBN)",
  "MLCG": "VERDE_(MLCG)",
  "MLCM": "NEUTRO_(MLCM)",
  "MLKE": "MORADO_(MLKE)",
  "MND": "NARANJO_(MND)",
  "MNL": "AZUL_(MNL)",
  "MNRO": "NARANJO_(MNRO)",
  "MNTP": "ROSADO_(MNTP)",
  "MOCN": "NEUTRO_(MOCN)",
  "MOKH": "CAFE_(MOKH)",
  "MOV": "VERDE_(MOV)",
  "MPI": "ROSADO_(MPI)",
  "MRC": "GRIS_(MRC)",
  "MRG": "VERDE_(MRG)",
  "MRLB": "CAFE_(MRLB)",
  "MRT": "CAFE_(MRT)",
  "MTNY": "AMARILLO_(MTNY)",
  "MUBN": "CAFE_(MUBN)",
  "MULB": "CAFE_(MULB)",
  "MUS": "AMARILLO_(MUS)",
  "MWA": "AZUL_(MWA)",
  "MYE": "AMARILLO_(MYE)",
  "MYPK": "ROSADO_(MYPK)",
  "MYSM": "MORADO_(MYSM)",
  "MYTG": "VERDE_(MYTG)",
  "MYYL": "AMARILLO_(MYYL)",
  "NAA": "NEUTRO_(NAA)",
  "NAAP": "NEUTRO_(NAAP)",
  "NABB": "NEUTRO_(NABB)",
  "NABE": "NEUTRO_(NABE)",
  "NABG": "NEUTRO_(NABG)",
  "NABL": "NEUTRO_(NABL)",
  "NABT": "NEUTRO_(NABT)",
  "NACC": "NEUTRO_(NACC)",
  "NACO": "NEUTRO_(NACO)",
  "NAD": "NARANJO_(NAD)",
  "NAE": "NEUTRO_(NAE)",
  "NAFG": "AZUL_(NAFG)",
  "NAFM": "NEUTRO_(NAFM)",
  "NAHM": "NEUTRO_(NAHM)",
  "NAHP": "NEUTRO_(NAHP)",
  "NAIB": "NEUTRO_(NAIB)",
  "NAIP": "NEUTRO_(NAIP)",
  "NALB": "NEUTRO_(NALB)",
  "NALG": "NEUTRO_(NALG)",
  "NALS": "NEUTRO_(NALS)",
  "NAMP": "AZUL_(NAMP)",
  "NANA": "NEUTRO_(NANA)",
  "NANB": "NEUTRO_(NANB)",
  "NANE": "NEUTRO_(NANE)",
  "NAOW": "NEUTRO_(NAOW)",
  "NAPG": "NEUTRO_(NAPG)",
  "NAPP": "NEUTRO_(NAPP)",
  "NARL": "AZUL_(NARL)",
  "NARP": "NEUTRO_(NARP)",
  "NARR": "NEUTRO_(NARR)",
  "NARU": "AZUL_(NARU)",
  "NASB": "NEUTRO_(NASB)",
  "NASC": "NEUTRO_(NASC)",
  "NASN": "AZUL_(NASN)",
  "NASV": "NEUTRO_(NASV)",
  "NAT": "NEUTRO_(NAT)",
  "NAUB": "NEUTRO_(NAUB)",
  "NAUT": "CAFE_(NAUT)",
  "NAVA": "AZUL_(NAVA)",
  "NAVR": "NEUTRO_(NAVR)",
  "NBAR": "NEUTRO_(NBAR)",
  "NBBB": "CAFE_(NBBB)",
  "NBDU": "CAFE_(NBDU)",
  "NBEB": "AZUL_(NBEB)",
  "NBGB": "AZUL_(NBGB)",
  "NBNP": "AZUL_(NBNP)",
  "NBO": "NEUTRO_(NBO)",
  "NBOR": "GRIS_(NBOR)",
  "NBPI": "CAFE_(NBPI)",
  "NBRA": "AZUL_(NBRA)",
  "NBRR": "AZUL_(NBRR)",
  "NBWA": "CAFE_(NBWA)",
  "NBWB": "AZUL_(NBWB)",
  "NCB": "NEUTRO_(NCB)",
  "NCBL": "GRIS_(NCBL)",
  "NCBR": "NEUTRO_(NCBR)",
  "NCC": "GRIS_(NCC)",
  "NCTY": "AMARILLO_(NCTY)",
  "NCV": "NEUTRO_(NCV)",
  "NDEK": "NEUTRO_(NDEK)",
  "NDHG": "GRIS_(NDHG)",
  "NDKA": "NEUTRO_(NDKA)",
  "NEBB": "AZUL_(NEBB)",
  "NEBG": "CAFE_(NEBG)",
  "NEBU": "AZUL_(NEBU)",
  "NELG": "AZUL_(NELG)",
  "NENA": "AZUL_(NENA)",
  "NENE": "AZUL_(NENE)",
  "NENK": "AZUL_(NENK)",
  "NENL": "AZUL_(NENL)",
  "NEP": "AZUL_(NEP)",
  "NEPG": "AZUL_(NEPG)",
  "NESB": "CAFE_(NESB)",
  "NESM": "AZUL_(NESM)",
  "NESS": "CAFE_(NESS)",
  "NESU": "AZUL_(NESU)",
  "NET": "GRIS_(NET)",
  "NETG": "VERDE_(NETG)",
  "NEWA": "AZUL_(NEWA)",
  "NEWH": "AZUL_(NEWH)",
  "NFE": "NEUTRO_(NFE)",
  "NFL": "NEGRO_(NFL)",
  "NFO": "GRIS_(NFO)",
  "NGLD": "NEUTRO_(NGLD)",
  "NGLG": "GRIS_(NGLG)",
  "NGRY": "GRIS_(NGRY)",
  "NGSA": "VERDE_(NGSA)",
  "NGSL": "VERDE_(NGSL)",
  "NHG": "GRIS_(NHG)",
  "NHTG": "VERDE_(NHTG)",
  "NIA": "AZUL_(NIA)",
  "NIBL": "GRIS_(NIBL)",
  "NIFD": "AZUL_(NIFD)",
  "NILG": "GRIS_(NILG)",
  "NIND": "NEUTRO_(NIND)",
  "NIPE": "GRIS_(NIPE)",
  "NJB": "GRIS_(NJB)",
  "NJVB": "NEUTRO_(NJVB)",
  "NKCL": "GRIS_(NKCL)",
  "NKCP": "GRIS_(NKCP)",
  "NKEP": "GRIS_(NKEP)",
  "NKFG": "GRIS_(NKFG)",
  "NKL": "GRIS_(NKL)",
  "NKLK": "GRIS_(NKLK)",
  "NKMB": "GRIS_(NKMB)",
  "NKMO": "GRIS_(NKMO)",
  "NKMP": "MORADO_(NKMP)",
  "NKNV": "GRIS_(NKNV)",
  "NKPS": "GRIS_(NKPS)",
  "NKRG": "GRIS_(NKRG)",
  "NKRS": "GRIS_(NKRS)",
  "NKWR": "GRIS_(NKWR)",
  "NLA": "NEUTRO_(NLA)",
  "NLAM": "GRIS_(NLAM)",
  "NLBE": "NEUTRO_(NLBE)",
  "NLBN": "NEUTRO_(NLBN)",
  "NLBR": "NEUTRO_(NLBR)",
  "NLBS": "NEUTRO_(NLBS)",
  "NLBU": "GRIS_(NLBU)",
  "NLCA": "NEUTRO_(NLCA)",
  "NLE": "AZUL_(NLE)",
  "NLEB": "AZUL_(NLEB)",
  "NLGN": "NEUTRO_(NLGN)",
  "NLHE": "GRIS_(NLHE)",
  "NLI": "AZUL_(NLI)",
  "NLJP": "NEUTRO_(NLJP)",
  "NLMA": "ROSADO_(NLMA)",
  "NLPA": "GRIS_(NLPA)",
  "NLPB": "NEUTRO_(NLPB)",
  "NLPE": "GRIS_(NLPE)",
  "NLPM": "NEUTRO_(NLPM)",
  "NLR": "NEUTRO_(NLR)",
  "NLSA": "GRIS_(NLSA)",
  "NLSP": "NEUTRO_(NLSP)",
  "NLTO": "NEUTRO_(NLTO)",
  "NLVA": "GRIS_(NLVA)",
  "NLYG": "VERDE_(NLYG)",
  "NMPI": "NEUTRO_(NMPI)",
  "NNBR": "AZUL_(NNBR)",
  "NNCR": "AZUL_(NNCR)",
  "NNGB": "AZUL_(NNGB)",
  "NNML": "AZUL_(NNML)",
  "NNOG": "GRIS_(NNOG)",
  "NNOL": "AZUL_(NNOL)",
  "NNPO": "AZUL_(NNPO)",
  "NNPU": "AZUL_(NNPU)",
  "NNSU": "AZUL_(NNSU)",
  "NNVB": "NEUTRO_(NNVB)",
  "NNWB": "AZUL_(NNWB)",
  "NOMG": "VERDE_(NOMG)",
  "NORG": "VERDE_(NORG)",
  "NPO": "NEUTRO_(NPO)",
  "NPPU": "NEUTRO_(NPPU)",
  "NPTR": "AZUL_(NPTR)",
  "NPU": "NEUTRO_(NPU)",
  "NRS": "VERDE_(NRS)",
  "NRU": "NEUTRO_(NRU)",
  "NSN": "NEUTRO_(NSN)",
  "NST": "ROJO_(NST)",
  "NSTR": "AZUL_(NSTR)",
  "NTCP": "NEUTRO_(NTCP)",
  "NTDS": "NEUTRO_(NTDS)",
  "NTGG": "NEUTRO_(NTGG)",
  "NTGN": "CAFE_(NTGN)",
  "NTLE": "NEUTRO_(NTLE)",
  "NTNB": "NEUTRO_(NTNB)",
  "NTPF": "NEUTRO_(NTPF)",
  "NTPL": "MORADO_(NTPL)",
  "NTQ": "NEUTRO_(NTQ)",
  "NTSB": "NEUTRO_(NTSB)",
  "NTSG": "NEUTRO_(NTSG)",
  "NTVL": "NEUTRO_(NTVL)",
  "NUDC": "NEUTRO_(NUDC)",
  "NUG": "GRIS_(NUG)",
  "NUVG": "VERDE_(NUVG)",
  "NVAB": "AZUL_(NVAB)",
  "NVBB": "AZUL_(NVBB)",
  "NVCR": "AZUL_(NVCR)",
  "NVDE": "AZUL_(NVDE)",
  "NVEC": "AZUL_(NVEC)",
  "NVFE": "AZUL_(NVFE)",
  "NVGN": "VERDE_(NVGN)",
  "NVK": "NEUTRO_(NVK)",
  "NVMA": "ROSADO_(NVMA)",
  "NVMR": "AZUL_(NVMR)",
  "NVNV": "GRIS_(NVNV)",
  "NVPS": "AZUL_(NVPS)",
  "NVTG": "AZUL_(NVTG)",
  "NVUW": "AZUL_(NVUW)",
  "NVYB": "AZUL_(NVYB)",
  "NWH": "BLANCO_(NWH)",
  "NWM": "NEUTRO_(NWM)",
  "NWNA": "AZUL_(NWNA)",
  "NYBL": "AZUL_(NYBL)",
  "NYSP": "AZUL_(NYSP)",
  "OAGR": "VERDE_(OAGR)",
  "OAHY": "NEUTRO_(OAHY)",
  "OAS": "AZUL_(OAS)",
  "OAT": "NEUTRO_(OAT)",
  "OBLG": "CAFE_(OBLG)",
  "OBPL": "MORADO_(OBPL)",
  "OCN": "AZUL_(OCN)",
  "OHDP": "NEUTRO_(OHDP)",
  "OHTL": "NEUTRO_(OHTL)",
  "OHVL": "NEUTRO_(OHVL)",
  "OHWB": "NEUTRO_(OHWB)",
  "OKBF": "CAFE_(OKBF)",
  "OKSB": "CAFE_(OKSB)",
  "OLBG": "NEUTRO_(OLBG)",
  "OLBI": "NEUTRO_(OLBI)",
  "OLGG": "VERDE_(OLGG)",
  "OLGN": "NEUTRO_(OLGN)",
  "OLHP": "NEUTRO_(OLHP)",
  "OLMA": "NEUTRO_(OLMA)",
  "OLSD": "NEUTRO_(OLSD)",
  "OLSG": "NEUTRO_(OLSG)",
  "OLTP": "NEUTRO_(OLTP)",
  "OLY": "ROJO_(OLY)",
  "ORB": "AZUL_(ORB)",
  "ORNA": "NEUTRO_(ORNA)",
  "ORPL": "NARANJO_(ORPL)",
  "ORSD": "AZUL_(ORSD)",
  "ORTN": "NEUTRO_(ORTN)",
  "OTBR": "CAFE_(OTBR)",
  "OTNC": "NEUTRO_(OTNC)",
  "OTNE": "NEUTRO_(OTNE)",
  "OTNL": "NEUTRO_(OTNL)",
  "OTSG": "NEUTRO_(OTSG)",
  "OTSM": "NEUTRO_(OTSM)",
  "OTVL": "NEUTRO_(OTVL)",
  "OTWH": "BLANCO_(OTWH)",
  "OVE": "VERDE_(OVE)",
  "OWBR": "CAFE_(OWBR)",
  "OWPP": "BLANCO_(OWPP)",
  "OXDR": "ROJO_(OXDR)",
  "OXRD": "ROJO_(OXRD)",
  "OYWH": "BLANCO_(OYWH)",
  "OZG": "VERDE_(OZG)",
  "PALG": "VERDE_(PALG)",
  "PANP": "MORADO_(PANP)",
  "PAP": "NARANJO_(PAP)",
  "PATN": "CAFE_(PATN)",
  "PAWK": "NEUTRO_(PAWK)",
  "PBBL": "AZUL_(PBBL)",
  "PBGY": "GRIS_(PBGY)",
  "PBH": "ROJO_(PBH)",
  "PBLE": "AZUL_(PBLE)",
  "PBN": "CAFE_(PBN)",
  "PCHS": "NARANJO_(PCHS)",
  "PCKP": "ROSADO_(PCKP)",
  "PDLP": "MORADO_(PDLP)",
  "PDP": "VERDE_(PDP)",
  "PEA": "AZUL_(PEA)",
  "PEB": "GRIS_(PEB)",
  "PEBG": "VERDE_(PEBG)",
  "PED": "NEUTRO_(PED)",
  "PEK": "NEUTRO_(PEK)",
  "PELP": "ROSADO_(PELP)",
  "PEM": "VERDE_(PEM)",
  "PEP": "ROJO_(PEP)",
  "PEPL": "MORADO_(PEPL)",
  "PEPU": "NEUTRO_(PEPU)",
  "PESB": "NEUTRO_(PESB)",
  "PEWG": "NEUTRO_(PEWG)",
  "PFGD": "AMARILLO_(PFGD)",
  "PGAB": "GRIS_(PGAB)",
  "PGBE": "AZUL_(PGBE)",
  "PGCL": "VERDE_(PGCL)",
  "PGEB": "AZUL_(PGEB)",
  "PGM": "BEIGE_(PGM)",
  "PGTA": "AMARILLO_(PGTA)",
  "PHGN": "VERDE_(PHGN)",
  "PHPL": "MORADO_(PHPL)",
  "PHS": "AMARILLO_(PHS)",
  "PHYE": "AMARILLO_(PHYE)",
  "PIBK": "AZUL_(PIBK)",
  "PIBL": "AZUL_(PIBL)",
  "PIC": "ROSADO_(PIC)",
  "PIG": "ROSADO_(PIG)",
  "PIGN": "VERDE_(PIGN)",
  "PIGR": "VERDE_(PIGR)",
  "PIMR": "ROJO_(PIMR)",
  "PINC": "CAFE_(PINC)",
  "PIO": "ROSADO_(PIO)",
  "PIPU": "MORADO_(PIPU)",
  "PIR": "AZUL_(PIR)",
  "PKDW": "NEUTRO_(PKDW)",
  "PKPK": "ROSADO_(PKPK)",
  "PKRK": "NEUTRO_(PKRK)",
  "PLCN": "NEUTRO_(PLCN)",
  "PLF": "VERDE_(PLF)",
  "PLGR": "VERDE_(PLGR)",
  "PLGY": "GRIS_(PLGY)",
  "PLIB": "NEUTRO_(PLIB)",
  "PLM": "MORADO_(PLM)",
  "PLNO": "NARANJO_(PLNO)",
  "PLNP": "ROSADO_(PLNP)",
  "PLP": "VERDE_(PLP)",
  "PLRB": "AZUL_(PLRB)",
  "PLT": "AMARILLO_(PLT)",
  "PLYP": "MORADO_(PLYP)",
  "PMFP": "MORADO_(PMFP)",
  "PMGR": "GRIS_(PMGR)",
  "PMI": "AZUL_(PMI)",
  "PMN": "ROSADO_(PMN)",
  "PMTP": "MORADO_(PMTP)",
  "PNDG": "VERDE_(PNDG)",
  "PNGR": "VERDE_(PNGR)",
  "PNKL": "NEUTRO_(PNKL)",
  "PNM": "GRIS_(PNM)",
  "PNSM": "NEUTRO_(PNSM)",
  "PNTB": "AZUL_(PNTB)",
  "POBL": "AZUL_(POBL)",
  "POFP": "ROSADO_(POFP)",
  "POM": "ROJO_(POM)",
  "POP": "ROJO_(POP)",
  "POW": "ROSADO_(POW)",
  "PPL": "AMARILLO_(PPL)",
  "PPLE": "AZUL_(PPLE)",
  "PPU": "GRIS_(PPU)",
  "PRB": "AZUL_(PRB)",
  "PRG": "AMARILLO_(PRG)",
  "PRL": "NEUTRO_(PRL)",
  "PRPI": "ROSADO_(PRPI)",
  "PRTA": "NEUTRO_(PRTA)",
  "PSKP": "MORADO_(PSKP)",
  "PSS": "VERDE_(PSS)",
  "PST": "VERDE_(PST)",
  "PTNU": "CAFE_(PTNU)",
  "PTP": "ROSADO_(PTP)",
  "PTPL": "MORADO_(PTPL)",
  "PTRE": "ROJO_(PTRE)",
  "PUBO": "NEUTRO_(PUBO)",
  "PUFT": "NEUTRO_(PUFT)",
  "PUM": "NEUTRO_(PUM)",
  "PUPL": "MORADO_(PUPL)",
  "PUR": "MORADO_(PUR)",
  "PUT": "NEUTRO_(PUT)",
  "PWBC": "AZUL_(PWBC)",
  "PWBE": "AZUL_(PWBE)",
  "PWBL": "AZUL_(PWBL)",
  "PWBN": "CAFE_(PWBN)",
  "PWBY": "AZUL_(PWBY)",
  "PWCA": "AMARILLO_(PWCA)",
  "PWCG": "VERDE_(PWCG)",
  "PWCH": "ROSADO_(PWCH)",
  "PWCO": "ROSADO_(PWCO)",
  "PWCR": "ROJO_(PWCR)",
  "PWCU": "AZUL_(PWCU)",
  "PWGN": "VERDE_(PWGN)",
  "PWIB": "NEGRO_(PWIB)",
  "PWKC": "CAFE_(PWKC)",
  "PWKO": "MORADO_(PWKO)",
  "PWL": "BLANCO_(PWL)",
  "PWNO": "GRIS_(PWNO)",
  "PWNU": "VERDE_(PWNU)",
  "PWP": "ROSADO_(PWP)",
  "PWPA": "ROJO_(PWPA)",
  "PWPU": "MORADO_(PWPU)",
  "PWRE": "ROJO_(PWRE)",
  "PWSA": "AMARILLO_(PWSA)",
  "PWSB": "AZUL_(PWSB)",
  "PWST": "AZUL_(PWST)",
  "PWSU": "AMARILLO_(PWSU)",
  "PWTA": "AZUL_(PWTA)",
  "PWVL": "AZUL_(PWVL)",
  "QTZ": "ROSADO_(QTZ)",
  "QZCO": "ROSADO_(QZCO)",
  "RAD": "AZUL_(RAD)",
  "RAF": "CAFE_(RAF)",
  "RAPI": "ROSADO_(RAPI)",
  "RASR": "ROJO_(RASR)",
  "RATN": "NEUTRO_(RATN)",
  "RAVR": "NEUTRO_(RAVR)",
  "RBE": "AZUL_(RBE)",
  "RBG": "NEUTRO_(RBG)",
  "RCF": "MORADO_(RCF)",
  "RDBS": "AZUL_(RDBS)",
  "RDC": "ROJO_(RDC)",
  "RDGB": "ROJO_(RDGB)",
  "RDMG": "ROSADO_(RDMG)",
  "RDPS": "ROSADO_(RDPS)",
  "RDS": "ROJO_(RDS)",
  "REGG": "VERDE_(REGG)",
  "REPI": "ROSADO_(REPI)",
  "RES": "ROJO_(RES)",
  "REW": "ROJO_(REW)",
  "REYE": "AMARILLO_(REYE)",
  "RFJH": "GRIS_(RFJH)",
  "RFO": "VERDE_(RFO)",
  "RGBY": "AMARILLO_(RGBY)",
  "RHP": "ROJO_(RHP)",
  "RHU": "ROJO_(RHU)",
  "RIRE": "ROJO_(RIRE)",
  "RIRN": "ROJO_(RIRN)",
  "RKH": "CAFE_(RKH)",
  "RKL": "GRIS_(RKL)",
  "RKML": "NARANJO_(RKML)",
  "RKP": "CAFE_(RKP)",
  "RKVT": "GRIS_(RKVT)",
  "RMBR": "ROJO_(RMBR)",
  "RMDC": "ROSADO_(RMDC)",
  "RMN": "ROJO_(RMN)",
  "RMRE": "ROJO_(RMRE)",
  "RNGP": "ROSADO_(RNGP)",
  "RNSG": "VERDE_(RNSG)",
  "RNY": "ROJO_(RNY)",
  "ROBN": "CAFE_(ROBN)",
  "ROR": "ROJO_(ROR)",
  "RORD": "ROJO_(RORD)",
  "ROSP": "ROSADO_(ROSP)",
  "ROY": "AZUL_(ROY)",
  "RPBN": "CAFE_(RPBN)",
  "RPK": "ROSADO_(RPK)",
  "RPN": "ROSADO_(RPN)",
  "RRD": "ROJO_(RRD)",
  "RSPK": "ROSADO_(RSPK)",
  "RSTP": "MORADO_(RSTP)",
  "RSWT": "ROSADO_(RSWT)",
  "RTK": "CAFE_(RTK)",
  "RTLR": "ROJO_(RTLR)",
  "RTMG": "ROSADO_(RTMG)",
  "RTSR": "ROJO_(RTSR)",
  "RTU": "ROSADO_(RTU)",
  "RVGN": "VERDE_(RVGN)",
  "RVN": "NEGRO_(RVN)",
  "RWD": "CAFE_(RWD)",
  "RWFT": "GRIS_(RWFT)",
  "RWL": "NEUTRO_(RWL)",
  "RYRF": "AMARILLO_(RYRF)",
  "RYSC": "AMARILLO_(RYSC)",
  "RYW": "AMARILLO_(RYW)",
  "SAGJ": "GRIS_(SAGJ)",
  "SALG": "GRIS_(SALG)",
  "SALN": "VERDE_(SALN)",
  "SAML": "NARANJO_(SAML)",
  "SARU": "NARANJO_(SARU)",
  "SBAL": "AZUL_(SBAL)",
  "SBBA": "AZUL_(SBBA)",
  "SBBL": "AZUL_(SBBL)",
  "SBDB": "AZUL_(SBDB)",
  "SBDP": "AZUL_(SBDP)",
  "SBDY": "GRIS_(SBDY)",
  "SBGA": "AZUL_(SBGA)",
  "SBGO": "AZUL_(SBGO)",
  "SBHP": "AZUL_(SBHP)",
  "SBLP": "AZUL_(SBLP)",
  "SBLR": "AZUL_(SBLR)",
  "SBMO": "AZUL_(SBMO)",
  "SBN": "CAFE_(SBN)",
  "SBNE": "AZUL_(SBNE)",
  "SBPE": "AZUL_(SBPE)",
  "SBPI": "AZUL_(SBPI)",
  "SBPP": "AZUL_(SBPP)",
  "SBRO": "AZUL_(SBRO)",
  "SBTE": "AZUL_(SBTE)",
  "SBWO": "AZUL_(SBWO)",
  "SCBE": "GRIS_(SCBE)",
  "SCPI": "ROSADO_(SCPI)",
  "SDAB": "AZUL_(SDAB)",
  "SDB": "CAFE_(SDB)",
  "SDG": "ROSADO_(SDG)",
  "SDL": "CAFE_(SDL)",
  "SDMG": "AZUL_(SDMG)",
  "SDNV": "AZUL_(SDNV)",
  "SEA": "VERDE_(SEA)",
  "SEFP": "ROSADO_(SEFP)",
  "SEGN": "VERDE_(SEGN)",
  "SEM": "VERDE_(SEM)",
  "SEMT": "CAFE_(SEMT)",
  "SEPT": "NEUTRO_(SEPT)",
  "SEQR": "ROJO_(SEQR)",
  "SFBL": "AZUL_(SFBL)",
  "SFM": "AZUL_(SFM)",
  "SFON": "NARANJO_(SFON)",
  "SFPI": "ROSADO_(SFPI)",
  "SGNV": "GRIS_(SGNV)",
  "SGPH": "GRIS_(SGPH)",
  "SGRY": "GRIS_(SGRY)",
  "SGYH": "GRIS_(SGYH)",
  "SHBN": "CAFE_(SHBN)",
  "SHE": "VERDE_(SHE)",
  "SHHS": "AZUL_(SHHS)",
  "SHKP": "ROSADO_(SHKP)",
  "SHLE": "VERDE_(SHLE)",
  "SHNY": "AMARILLO_(SHNY)",
  "SHRG": "VERDE_(SHRG)",
  "SIBR": "CAFE_(SIBR)",
  "SIL": "GRIS_(SIL)",
  "SINY": "CAFE_(SINY)",
  "SIT": "VERDE_(SIT)",
  "SKA": "VERDE_(SKA)",
  "SKCL": "VERDE_(SKCL)",
  "SKPB": "AZUL_(SKPB)",
  "SKY": "AZUL_(SKY)",
  "SLBL": "AZUL_(SLBL)",
  "SLD": "MORADO_(SLD)",
  "SLKH": "NEUTRO_(SLKH)",
  "SLPU": "MORADO_(SLPU)",
  "SLS": "VERDE_(SLS)",
  "SLVG": "VERDE_(SLVG)",
  "SMBA": "AZUL_(SMBA)",
  "SMBU": "AZUL_(SMBU)",
  "SMC": "ROSADO_(SMC)",
  "SMDB": "AZUL_(SMDB)",
  "SMFE": "AZUL_(SMFE)",
  "SMFO": "AZUL_(SMFO)",
  "SMK": "AZUL_(SMK)",
  "SMKG": "VERDE_(SMKG)",
  "SMOC": "AZUL_(SMOC)",
  "SMON": "AZUL_(SMON)",
  "SMRE": "AZUL_(SMRE)",
  "SMSB": "AZUL_(SMSB)",
  "SMST": "AZUL_(SMST)",
  "SNBE": "AZUL_(SNBE)",
  "SNBL": "AZUL_(SNBL)",
  "SNDB": "AZUL_(SNDB)",
  "SNK": "ROSADO_(SNK)",
  "SNL": "GRIS_(SNL)",
  "SNLP": "ROSADO_(SNLP)",
  "SNM": "VERDE_(SNM)",
  "SNPU": "ROSADO_(SNPU)",
  "SNS": "NARANJO_(SNS)",
  "SOCO": "NARANJO_(SOCO)",
  "SOF": "ROSADO_(SOF)",
  "SORF": "NARANJO_(SORF)",
  "SORG": "VERDE_(SORG)",
  "SOV": "VERDE_(SOV)",
  "SPCL": "ROSADO_(SPCL)",
  "SPCU": "ROSADO_(SPCU)",
  "SPLG": "VERDE_(SPLG)",
  "SPRB": "AZUL_(SPRB)",
  "SPRE": "ROJO_(SPRE)",
  "SPRK": "ROSADO_(SPRK)",
  "SPSU": "ROSADO_(SPSU)",
  "SPT": "AZUL_(SPT)",
  "SPTG": "VERDE_(SPTG)",
  "SPTO": "NARANJO_(SPTO)",
  "SPYG": "VERDE_(SPYG)",
  "SRAP": "ROSADO_(SRAP)",
  "SRL": "AZUL_(SRL)",
  "SRPK": "ROSADO_(SRPK)",
  "SSM": "NEUTRO_(SSM)",
  "SSO": "NEUTRO_(SSO)",
  "STBL": "AZUL_(STBL)",
  "STGN": "VERDE_(STGN)",
  "STH": "GRIS_(STH)",
  "STHK": "GRIS_(STHK)",
  "STLE": "AZUL_(STLE)",
  "STM": "AZUL_(STM)",
  "STMA": "MORADO_(STMA)",
  "STME": "AZUL_(STME)",
  "STN": "GRIS_(STN)",
  "STOR": "AZUL_(STOR)",
  "STPE": "ROSADO_(STPE)",
  "STPI": "ROSADO_(STPI)",
  "STRB": "AZUL_(STRB)",
  "STSO": "AZUL_(STSO)",
  "STTR": "ROJO_(STTR)",
  "STWB": "AMARILLO_(STWB)",
  "STWN": "GRIS_(STWN)",
  "STYM": "MORADO_(STYM)",
  "STYW": "AMARILLO_(STYW)",
  "SUBA": "AZUL_(SUBA)",
  "SUCG": "VERDE_(SUCG)",
  "SUGR": "VERDE_(SUGR)",
  "SUIB": "AZUL_(SUIB)",
  "SUL": "MORADO_(SUL)",
  "SULY": "AMARILLO_(SULY)",
  "SUMR": "ROJO_(SUMR)",
  "SUNA": "AZUL_(SUNA)",
  "SUP": "VERDE_(SUP)",
  "SUS": "AMARILLO_(SUS)",
  "SUYE": "AMARILLO_(SUYE)",
  "SVIL": "MORADO_(SVIL)",
  "SVSB": "MORADO_(SVSB)",
  "SWCI": "GRIS_(SWCI)",
  "SWD": "VERDE_(SWD)",
  "SWHT": "TURQUESA_(SWHT)",
  "SWO": "GRIS_(SWO)",
  "SWR": "NARANJO_(SWR)",
  "SYSQ": "AMARILLO_(SYSQ)",
  "SZRD": "ROJO_(SZRD)",
  "TAB": "CAFE_(TAB)",
  "TAN": "CAFE_(TAN)",
  "TATE": "AZUL_(TATE)",
  "TATG": "GRIS_(TATG)",
  "TBGB": "AZUL_(TBGB)",
  "TDG": "VERDE_(TDG)",
  "TDRP": "MORADO_(TDRP)",
  "TDT": "VERDE_(TDT)",
  "TEAG": "VERDE_(TEAG)",
  "TED": "VERDE_(TED)",
  "TGBE": "VERDE_(TGBE)",
  "TGN": "VERDE_(TGN)",
  "TGOR": "NARANJO_(TGOR)",
  "TGRD": "ROJO_(TGRD)",
  "TGRN": "VERDE_(TGRN)",
  "TGY": "GRIS_(TGY)",
  "THI": "AZUL_(THI)",
  "THR": "NARANJO_(THR)",
  "TIBO": "AZUL_(TIBO)",
  "TIC": "AZUL_(TIC)",
  "TIDB": "AZUL_(TIDB)",
  "TINT": "NEUTRO_(TINT)",
  "TIYP": "GRIS_(TIYP)",
  "TKT": "GRIS_(TKT)",
  "TKW": "CAFE_(TKW)",
  "TLCR": "GRIS_(TLCR)",
  "TLE": "AZUL_(TLE)",
  "TLFG": "GRIS_(TLFG)",
  "TLGR": "VERDE_(TLGR)",
  "TLSM": "GRIS_(TLSM)",
  "TMBG": "VERDE_(TMBG)",
  "TMBL": "AZUL_(TMBL)",
  "TMBR": "CAFE_(TMBR)",
  "TMI": "NARANJO_(TMI)",
  "TMPL": "MORADO_(TMPL)",
  "TMT": "ROJO_(TMT)",
  "TNGO": "AMARILLO_(TNGO)",
  "TNGR": "VERDE_(TNGR)",
  "TNM": "GRIS_(TNM)",
  "TOL": "VERDE_(TOL)",
  "TOPB": "CAFE_(TOPB)",
  "TOPE": "CAFE_(TOPE)",
  "TOYR": "ROJO_(TOYR)",
  "TPB": "CAFE_(TPB)",
  "TPBB": "GRIS_(TPBB)",
  "TPBL": "AZUL_(TPBL)",
  "TPGN": "VERDE_(TPGN)",
  "TPLU": "GRIS_(TPLU)",
  "TPND": "CAFE_(TPND)",
  "TRBN": "CAFE_(TRBN)",
  "TRLG": "VERDE_(TRLG)",
  "TRNG": "VERDE_(TRNG)",
  "TRP": "MORADO_(TRP)",
  "TRPB": "CAFE_(TRPB)",
  "TRPI": "ROSADO_(TRPI)",
  "TRQ": "AZUL_(TRQ)",
  "TRUT": "VERDE_(TRUT)",
  "TRX": "NEGRO_(TRX)",
  "TSGE": "VERDE_(TSGE)",
  "TSTW": "BLANCO_(TSTW)",
  "TTPS": "AZUL_(TTPS)",
  "TTWD": "AZUL_(TTWD)",
  "TUBL": "AZUL_(TUBL)",
  "TUBT": "CAFE_(TUBT)",
  "TUCV": "AZUL_(TUCV)",
  "TWGT": "CAFE_(TWGT)",
  "TWP": "GRIS_(TWP)",
  "TXTG": "VERDE_(TXTG)",
  "TYO": "AMARILLO_(TYO)",
  "UBTL": "AZUL_(UBTL)",
  "UDNL": "NEUTRO_(UDNL)",
  "UGN": "VERDE_(UGN)",
  "ULBE": "AZUL_(ULBE)",
  "ULPK": "ROSADO_(ULPK)",
  "ULT": "AZUL_(ULT)",
  "UMBR": "CAFE_(UMBR)",
  "UPBL": "AZUL_(UPBL)",
  "UTB": "AZUL_(UTB)",
  "UWFR": "AZUL_(UWFR)",
  "UWNV": "AZUL_(UWNV)",
  "UWPL": "AZUL_(UWPL)",
  "UWRA": "AZUL_(UWRA)",
  "UWTB": "AZUL_(UWTB)",
  "VAPC": "NARANJO_(VAPC)",
  "VDGS": "VERDE_(VDGS)",
  "VEPC": "NARANJO_(VEPC)",
  "VERP": "MORADO_(VERP)",
  "VGO": "NEUTRO_(VGO)",
  "VIK": "AZUL_(VIK)",
  "VIM": "NARANJO_(VIM)",
  "VIO": "MORADO_(VIO)",
  "VJOG": "VERDE_(VJOG)",
  "VKNB": "AZUL_(VKNB)",
  "VLBE": "AZUL_(VLBE)",
  "VLKH": "NEUTRO_(VLKH)",
  "VLTB": "AZUL_(VLTB)",
  "VLTI": "MORADO_(VLTI)",
  "VOB": "AZUL_(VOB)",
  "VPSG": "MORADO_(VPSG)",
  "VPSU": "NARANJO_(VPSU)",
  "VRTB": "AZUL_(VRTB)",
  "VSLB": "AZUL_(VSLB)",
  "VVB": "CAFE_(VVB)",
  "VVV": "MORADO_(VVV)",
  "VYG": "VERDE_(VYG)",
  "VYL": "AMARILLO_(VYL)",
  "WACG": "AZUL_(WACG)",
  "WASR": "AZUL_(WASR)",
  "WAVB": "AZUL_(WAVB)",
  "WAX": "ROJO_(WAX)",
  "WBEG": "BLANCO_(WBEG)",
  "WBEU": "BLANCO_(WBEU)",
  "WBGN": "BLANCO_(WBGN)",
  "WBLR": "AZUL_(WBLR)",
  "WBPU": "AZUL_(WBPU)",
  "WBSB": "BLANCO_(WBSB)",
  "WBSE": "BLANCO_(WBSE)",
  "WCBL": "BLANCO_(WCBL)",
  "WCH": "NEUTRO_(WCH)",
  "WCOI": "BLANCO_(WCOI)",
  "WCRS": "BLANCO_(WCRS)",
  "WCUB": "BLANCO_(WCUB)",
  "WCVC": "BLANCO_(WCVC)",
  "WCY": "BLANCO_(WCY)",
  "WDL": "VERDE_(WDL)",
  "WDMA": "BLANCO_(WDMA)",
  "WDN": "CAFE_(WDN)",
  "WDOB": "BLANCO_(WDOB)",
  "WDOR": "BLANCO_(WDOR)",
  "WDRB": "CAFE_(WDRB)",
  "WDRK": "BLANCO_(WDRK)",
  "WDS": "ROSADO_(WDS)",
  "WEFR": "BLANCO_(WEFR)",
  "WESN": "BLANCO_(WESN)",
  "WETN": "BLANCO_(WETN)",
  "WEWH": "BLANCO_(WEWH)",
  "WFAB": "BLANCO_(WFAB)",
  "WFCR": "BLANCO_(WFCR)",
  "WFEA": "BLANCO_(WFEA)",
  "WFG": "VERDE_(WFG)",
  "WFR": "BLANCO_(WFR)",
  "WFTB": "BLANCO_(WFTB)",
  "WFTP": "BLANCO_(WFTP)",
  "WFW": "MORADO_(WFW)",
  "WGLG": "BLANCO_(WGLG)",
  "WHAB": "BLANCO_(WHAB)",
  "WHAL": "BLANCO_(WHAL)",
  "WHBB": "BLANCO_(WHBB)",
  "WHBI": "BLANCO_(WHBI)",
  "WHBR": "BLANCO_(WHBR)",
  "WHBT": "BLANCO_(WHBT)",
  "WHBU": "BLANCO_(WHBU)",
  "WHCE": "BLANCO_(WHCE)",
  "WHCN": "BLANCO_(WHCN)",
  "WHCP": "ROSADO_(WHCP)",
  "WHFG": "BLANCO_(WHFG)",
  "WHGR": "BLANCO_(WHGR)",
  "WHI": "BLANCO_(WHI)",
  "WHID": "BLANCO_(WHID)",
  "WHIK": "BLANCO_(WHIK)",
  "WHIS": "BLANCO_(WHIS)",
  "WHIT": "BLANCO_(WHIT)",
  "WHLM": "BLANCO_(WHLM)",
  "WHLT": "BLANCO_(WHLT)",
  "WHMB": "BLANCO_(WHMB)",
  "WHN": "BLANCO_(WHN)",
  "WHNB": "BLANCO_(WHNB)",
  "WHP": "MORADO_(WHP)",
  "WHPG": "BLANCO_(WHPG)",
  "WHPI": "ROSADO_(WHPI)",
  "WHRL": "BLANCO_(WHRL)",
  "WHSH": "BLANCO_(WHSH)",
  "WHSK": "BLANCO_(WHSK)",
  "WHSN": "BLANCO_(WHSN)",
  "WHSO": "BLANCO_(WHSO)",
  "WHST": "BLANCO_(WHST)",
  "WHSU": "BLANCO_(WHSU)",
  "WHT": "BLANCO_(WHT)",
  "WHTB": "BLANCO_(WHTB)",
  "WHTT": "BLANCO_(WHTT)",
  "WHVI": "BLANCO_(WHVI)",
  "WHVP": "BLANCO_(WHVP)",
  "WHWA": "BLANCO_(WHWA)",
  "WIBL": "AZUL_(WIBL)",
  "WIBN": "BLANCO_(WIBN)",
  "WIL": "VERDE_(WIL)",
  "WINA": "BLANCO_(WINA)",
  "WISQ": "BLANCO_(WISQ)",
  "WIT": "BLANCO_(WIT)",
  "WITN": "BLANCO_(WITN)",
  "WIWA": "BLANCO_(WIWA)",
  "WKFO": "BLANCO_(WKFO)",
  "WKLB": "CAFE_(WKLB)",
  "WLDB": "AZUL_(WLDB)",
  "WLGY": "BLANCO_(WLGY)",
  "WLWT": "BLANCO_(WLWT)",
  "WNEB": "BLANCO_(WNEB)",
  "WNGY": "GRIS_(WNGY)",
  "WNVO": "BLANCO_(WNVO)",
  "WOBK": "CAFE_(WOBK)",
  "WOBL": "AZUL_(WOBL)",
  "WOBR": "CAFE_(WOBR)",
  "WOCL": "AZUL_(WOCL)",
  "WOT": "NEUTRO_(WOT)",
  "WOTN": "BLANCO_(WOTN)",
  "WPAL": "BLANCO_(WPAL)",
  "WPBE": "BLANCO_(WPBE)",
  "WPIP": "BLANCO_(WPIP)",
  "WPKP": "ROSADO_(WPKP)",
  "WPYG": "VERDE_(WPYG)",
  "WQTZ": "BLANCO_(WQTZ)",
  "WRDB": "BLANCO_(WRDB)",
  "WRGO": "CAFE_(WRGO)",
  "WSG": "VERDE_(WSG)",
  "WSPB": "BLANCO_(WSPB)",
  "WSTA": "BLANCO_(WSTA)",
  "WSTO": "VERDE_(WSTO)",
  "WSY": "AZUL_(WSY)",
  "WTBE": "BLANCO_(WTBE)",
  "WTBK": "BLANCO_(WTBK)",
  "WTC": "VERDE_(WTC)",
  "WTEB": "AZUL_(WTEB)",
  "WTGY": "BLANCO_(WTGY)",
  "WTHQ": "BLANCO_(WTHQ)",
  "WTMA": "BLANCO_(WTMA)",
  "WTME": "BLANCO_(WTME)",
  "WTMP": "BLANCO_(WTMP)",
  "WTRK": "BLANCO_(WTRK)",
  "WTRO": "BLANCO_(WTRO)",
  "WTRR": "BLANCO_(WTRR)",
  "WTSM": "BLANCO_(WTSM)",
  "WTSY": "BLANCO_(WTSY)",
  "WTYR": "BLANCO_(WTYR)",
  "WTYY": "BLANCO_(WTYY)",
  "WVLB": "BLANCO_(WVLB)",
  "WWO": "CAFE_(WWO)",
  "WWW": "BLANCO_(WWW)",
  "WXY": "AMARILLO_(WXY)",
  "WYGN": "VERDE_(WYGN)",
  "XGRY": "GRIS_(XGRY)",
  "YKYW": "AMARILLO_(YKYW)",
  "YRTY": "AMARILLO_(YRTY)",
  "YSDY": "AMARILLO_(YSDY)",
  "YSMY": "AMARILLO_(YSMY)",
  "YUC": "VERDE_(YUC)",
  "ZOO": "NEUTRO_(ZOO)",
  "ZZZ": "NEUTRO_(ZZZ)",
  "CEBK": "NEGRO_(CEBK)",
  "FTRB": "NEGRO_(FTRB)",
  "WNSM": "AZUL_(WNSM)",
  "MTBN": "VERDE_(MTBN)",
  "SPBA": "VERDE_(SPBA)",
  "FMTB": "VERDE_(FMTB)",
  "DPCO": "CAFE_(DPCO)",
  "HKCO": "CAFE_(HKCO)",
  "TLSE": "ROJO_(TLSE)",
  "TLSD": "GRIS_(TLSD)",
  "OLRD": "ROJO_(OLRD)",
  "RVAM": "ROJO_(RVAM)",
  "SPWI": "GRIS_(SPWI)",
  "FZNE": "AZUL_(FZNE)",
  "SENN": "AZUL_(SENN)",
  "AFBL": "AZUL_(AFBL)",
  "DIUB": "AZUL_(DIUB)",
  "RSTU": "AZUL_(RSTU)",
  "TLUP": "AZUL_(TLUP)",
  "AIBL": "NEGRO_(AIBL)",
  "CINB": "NEGRO_(CINB)",
  "RQIN": "NEGRO_(RQIN)",
  "SCBK": "NEGRO_(SCBK)",
  "CGNX": "VERDE_(CGNX)",
  "DPCA": "VERDE_(DPCA)",
  "FZCA": "VERDE_(FZCA)",
  "SOLC": "VERDE_(SOLC)",
  "BFCL": "AZUL_(BFCL)",
  "CMBX": "AZUL_(CMBX)",
  "DWCL": "AZUL_(DWCL)",
  "SCLX": "AZUL_(SCLX)",
  "FOGN": "VERDE_(FOGN)",
  "SEOG": "VERDE_(SEOG)",
  "SODG": "VERDE_(SODG)",
  "SSOL": "VERDE_(SSOL)",
  "TOLG": "VERDE_(TOLG)",
  "WVGN": "VERDE_(WVGN)",
  "CYSN": "AZUL_(CYSN)",
  "FLSK": "AZUL_(FLSK)",
  "MTSU": "AZUL_(MTSU)",
  "SSKN": "AZUL_(SSKN)",
  "BCKO": "CAFE_(BCKO)",
  "ROTB": "CAFE_(ROTB)",
  "TLPM": "MORADO_(TLPM)",
  "FFCX": "AZUL_(FFCX)",
  "POCT": "AZUL_(POCT)",
  "DEPL": "GRIS_(DEPL)",
  "MFPL": "GRIS_(MFPL)",
  "FTRD": "ROJO_(FTRD)",
  "SPVA": "CAFE_(SPVA)",
  "STVA": "ROJO_(STVA)",
  "TLVA": "CAFE_(TLVA)",
  "WNVA": "ROJO_(WNVA)",
  "APML": "CAFE_(APML)",
  "FLMA": "CAFE_(FLMA)",
  "PFML": "CAFE_(PFML)",
  "PKML": "CAFE_(PKML)",
  "SHMA": "CAFE_(SHMA)",
  "OLBB": "AZUL_(OLBB)",
  "PKSB": "AZUL_(PKSB)",
  "PLBC": "AZUL_(PLBC)",
  "POBB": "AZUL_(POBB)",
  "SRKI": "NEUTRO_(SRKI)",
  "CREX": "VERDE_(CREX)",
  "FEWX": "VERDE_(FEWX)",
  "PFEL": "VERDE_(PFEL)",
  "SEWX": "VERDE_(SEWX)",
  "WELX": "VERDE_(WELX)",
  "CDBN": "CAFE_(CDBN)",
  "CHDE": "CAFE_(CHDE)",
  "DEBN": "CAFE_(DEBN)",
  "NFRG": "VERDE_(NFRG)",
  "LRCL": "NEUTRO_(LRCL)",
  "SRRO": "CAFE_(SRRO)",
  "RVPO": "ROJO_(RVPO)",
  "SRPO": "ROJO_(SRPO)",
  "OSNB": "CAFE_(OSNB)",
  "POVL": "AZUL_(POVL)",
  "SLVI": "AZUL_(SLVI)",
  "SKFL": "AZUL_(SKFL)",
  "APTG": "AMARILLO_(APTG)",
  "DITG": "AMARILLO_(DITG)",
  "DRTX": "AMARILLO_(DRTX)",
  "PKTA": "AMARILLO_(PKTA)",
  "PTGO": "AMARILLO_(PTGO)",
  "SHGO": "AMARILLO_(SHGO)",
  "SPGO": "AMARILLO_(SPGO)",
  "BGPU": "MORADO_(BGPU)",
  "DIBP": "MORADO_(DIBP)",
  "OLBP": "MORADO_(OLBP)",
  "PLBP": "MORADO_(PLBP)",
  "SBPX": "MORADO_(SBPX)",
  "SLBP": "MORADO_(SLBP)",
  "BMPX": "ROSADO_(BMPX)",
  "SMTX": "ROSADO_(SMTX)",
  "TMPI": "ROSADO_(TMPI)",
  "EVLG": "VERDE_(EVLG)",
  "TLIG": "VERDE_(TLIG)",
  "OLPM": "NEUTRO_(OLPM)",
  "CHDA": "NEUTRO_(CHDA)",
  "LWDA": "NEUTRO_(LWDA)",
  "RQDA": "BLANCO_(RQDA)",
  "SLDA": "CAFE_(SLDA)",
  "CSRX": "ROJO_(CSRX)",
  "FSRD": "ROJO_(FSRD)",
  "PLSI": "ROJO_(PLSI)",
  "PLNY": "VERDE_(PLNY)",
  "FLDO": "BLANCO_(FLDO)",
  "CONL": "BLANCO_(CONL)",
  "SNAL": "NEUTRO_(SNAL)",
  "PUNL": "NEUTRO_(PUNL)",
  "FLTE": "AZUL_(FLTE)",
  "LFPU": "MORADO_(LFPU)",
  "STXB": "NEGRO_(STXB)",
  "TLBK": "NEGRO_(TLBK)",
  "UNBL": "NEGRO_(UNBL)",
  "WVBK": "NEGRO_(WVBK)",
  "NASM": "AZUL_(NASM)",
  "DIUT": "AZUL_(DIUT)",
  "CLFO": "GRIS_(CLFO)",
  "FTLF": "GRIS_(FTLF)",
  "CLSD": "GRIS_(CLSD)",
  "HBSD": "GRIS_(HBSD)",
  "BLSE": "GRIS_(BLSE)",
  "MFSG": "GRIS_(MFSG)",
  "BTNE": "AZUL_(BTNE)",
  "FSBN": "AZUL_(FSBN)",
  "FSTN": "AZUL_(FSTN)",
  "WFNA": "AZUL_(WFNA)",
  "BLNY": "AZUL_(BLNY)",
  "BYNN": "AZUL_(BYNN)",
  "SLDN": "AZUL_(SLDN)",
  "SFTL": "AZUL_(SFTL)",
  "SSTI": "AZUL_(SSTI)",
  "WBTI": "AZUL_(WBTI)",
  "FZIN": "NEGRO_(FZIN)",
  "LFIN": "NEGRO_(LFIN)",
  "SKLI": "NEGRO_(SKLI)",
  "UNIB": "NEGRO_(UNIB)",
  "BTED": "AZUL_(BTED)",
  "RMLE": "AZUL_(RMLE)",
  "SLGE": "AZUL_(SLGE)",
  "WTLX": "AZUL_(WTLX)",
  "BLWE": "AZUL_(BLWE)",
  "BTLW": "AZUL_(BTLW)",
  "BTWE": "AZUL_(BTWE)",
  "BTWX": "AZUL_(BTWX)",
  "FLWE": "AZUL_(FLWE)",
  "FNWE": "AZUL_(FNWE)",
  "MTWE": "AZUL_(MTWE)",
  "PLWE": "AZUL_(PLWE)",
  "SDWX": "AZUL_(SDWX)",
  "SFWE": "AZUL_(SFWE)",
  "SKWX": "AZUL_(SKWX)",
  "SWLX": "AZUL_(SWLX)",
  "QFWE": "AZUL_(QFWE)",
  "SAWL": "AZUL_(SAWL)",
  "WBWE": "AZUL_(WBWE)",
  "WRWE": "AZUL_(WRWE)",
  "POHL": "VERDE_(POHL)",
  "RSHL": "VERDE_(RSHL)",
  "BFHL": "VERDE_(BFHL)",
  "MAHG": "VERDE_(MAHG)",
  "QFHE": "VERDE_(QFHE)",
  "BFSL": "AZUL_(BFSL)",
  "KALS": "AZUL_(KALS)",
  "MBSL": "AZUL_(MBSL)",
  "RASL": "AZUL_(RASL)",
  "SLGS": "AZUL_(SLGS)",
  "SSTL": "AZUL_(SSTL)",
  "TSLB": "AZUL_(TSLB)",
  "WWST": "AZUL_(WWST)",
  "IMSO": "MORADO_(IMSO)",
  "STPU": "MORADO_(STPU)",
  "FSHF": "GRIS_(FSHF)",
  "RWFO": "GRIS_(RWFO)",
  "ABTX": "AZUL_(ABTX)",
  "BTLA": "AZUL_(BTLA)",
  "CRAX": "AZUL_(CRAX)",
  "FIAX": "AZUL_(FIAX)",
  "PMDA": "AZUL_(PMDA)",
  "RBWA": "AZUL_(RBWA)",
  "SDAX": "AZUL_(SDAX)",
  "TLAX": "AZUL_(TLAX)",
  "UNFA": "AZUL_(UNFA)",
  "WFZA": "AZUL_(WFZA)",
  "FLRA": "AZUL_(FLRA)",
  "FZTG": "VERDE_(FZTG)",
  "PSMT": "VERDE_(PSMT)",
  "SFTE": "VERDE_(SFTE)",
  "SPTE": "VERDE_(SPTE)",
  "TLTE": "VERDE_(TLTE)",
  "WBTE": "VERDE_(WBTE)",
  "HBFE": "GRIS_(HBFE)",
  "GRZX": "VERDE_(GRZX)",
  "BLGZ": "VERDE_(BLGZ)",
  "CRGX": "VERDE_(CRGX)",
  "WBGX": "VERDE_(WBGX)",
  "WRGX": "VERDE_(WRGX)",
  "FJRI": "VERDE_(FJRI)",
  "FTRV": "VERDE_(FTRV)",
  "PNRI": "VERDE_(PNRI)",
  "WIRV": "VERDE_(WIRV)",
  "WLRI": "VERDE_(WLRI)",
  "SNRI": "GRIS_(SNRI)",
  "WWRI": "VERDE_(WWRI)",
  "LFTN": "NEUTRO_(LFTN)",
  "SRCL": "NEUTRO_(SRCL)",
  "ACPX": "MORADO_(ACPX)",
  "FCPX": "MORADO_(FCPX)",
  "LFCO": "MORADO_(LFCO)",
  "SCPX": "MORADO_(SCPX)",
  "SRPU": "MORADO_(SRPU)",
  "STCX": "MORADO_(STCX)",
  "RWCO": "MORADO_(RWCO)",
  "CLRN": "CAFE_(CLRN)",
  "CLRO": "CAFE_(CLRO)",
  "RMTR": "CAFE_(RMTR)",
  "SKRN": "CAFE_(SKRN)",
  "SSRB": "CAFE_(SSRB)",
  "SDTM": "AZUL_(SDTM)",
  "SKTM": "AZUL_(SKTM)",
  "SSTH": "AZUL_(SSTH)",
  "BATL": "AZUL_(BATL)",
  "BFTM": "AZUL_(BFTM)",
  "RWTL": "AZUL_(RWTL)",
  "WBTL": "AZUL_(WBTL)",
  "SDSI": "CAFE_(SDSI)",
  "BFSA": "GRIS_(BFSA)",
  "SLDS": "GRIS_(SLDS)",
  "POMV": "MORADO_(POMV)",
  "RNGX": "VERDE_(RNGX)",
  "FRNX": "VERDE_(FRNX)",
  "FZRI": "VERDE_(FZRI)",
  "LFRI": "VERDE_(LFRI)",
  "SRLG": "VERDE_(SRLG)",
  "SRNX": "VERDE_(SRNX)",
  "UFRX": "VERDE_(UFRX)",
  "MMRG": "VERDE_(MMRG)",
  "PRGN": "VERDE_(PRGN)",
  "SMRN": "VERDE_(SMRN)",
  "MBSO": "NARANJO_(MBSO)",
  "BLFL": "AZUL_(BLFL)",
  "FMBL": "AZUL_(FMBL)",
  "FTFL": "AZUL_(FTFL)",
  "TLFL": "AZUL_(TLFL)",
  "WPFL": "AZUL_(WPFL)",
  "MTFL": "AZUL_(MTFL)",
  "SFBN": "VERDE_(SFBN)",
  "SRLB": "VERDE_(SRLB)",
  "WFBN": "VERDE_(WFBN)",
  "WRBU": "VERDE_(WRBU)",
  "IMTA": "ROSADO_(IMTA)",
  "FSPL": "MORADO_(FSPL)",
  "MTFO": "MORADO_(MTFO)",
  "TLPL": "MORADO_(TLPL)",
  "UNFP": "MORADO_(UNFP)",
  "NFCG": "GRIS_(NFCG)",
  "FSPO": "NARANJO_(FSPO)",
  "WRPO": "NARANJO_(WRPO)",
  "APMX": "NEUTRO_(APMX)",
  "BPMX": "NEUTRO_(BPMX)",
  "CPMX": "NEUTRO_(CPMX)",
  "CRPX": "NEUTRO_(CRPX)",
  "FRPX": "NEUTRO_(FRPX)",
  "FZPM": "NEUTRO_(FZPM)",
  "PIPX": "NEUTRO_(PIPX)",
  "WBPX": "NEUTRO_(WBPX)",
  "WRPX": "NEUTRO_(WRPX)",
  "RKMX": "NARANJO_(RKMX)",
  "BFME": "NARANJO_(BFME)",
  "CMLX": "NARANJO_(CMLX)",
  "FSML": "NARANJO_(FSML)",
  "GAML": "NARANJO_(GAML)",
  "SDME": "NARANJO_(SDME)",
  "SKMX": "NARANJO_(SKMX)",
  "SNRO": "NARANJO_(SNRO)",
  "LMPX": "ROSADO_(LMPX)",
  "CCLX": "ROSADO_(CCLX)",
  "FSLU": "ROSADO_(FSLU)",
  "SPLM": "ROSADO_(SPLM)",
  "WLPX": "ROSADO_(WLPX)",
  "FMHE": "NARANJO_(FMHE)",
  "FSHL": "NARANJO_(FSHL)",
  "PNHE": "NARANJO_(PNHE)",
  "RMHE": "NARANJO_(RMHE)",
  "BBTU": "NEUTRO_(BBTU)",
  "LFNL": "NEUTRO_(LFNL)",
  "SSNL": "NEUTRO_(SSNL)",
  "WWNL": "BLANCO_(WWNL)",
  "PTLP": "ROSADO_(PTLP)",
  "RMLP": "ROSADO_(RMLP)",
  "BPGX": "AMARILLO_(BPGX)",
  "AIBX": "AMARILLO_(AIBX)",
  "FTBE": "AMARILLO_(FTBE)",
  "PLBT": "AMARILLO_(PLBT)",
  "SBXX": "AMARILLO_(SBXX)",
  "DMBT": "AMARILLO_(DMBT)",
  "LTBE": "AMARILLO_(LTBE)",
  "MFBN": "AMARILLO_(MFBN)",
  "BFWI": "BLANCO_(BFWI)",
  "SHBI": "BLANCO_(SHBI)",
  "BTBU": "AMARILLO_(BTBU)",
  "FSBB": "AMARILLO_(FSBB)",
  "GABP": "AMARILLO_(GABP)",
  "PLBY": "AMARILLO_(PLBY)",
  "POBY": "AMARILLO_(POBY)",
  "RMBY": "AMARILLO_(RMBY)",
  "BZYE": "AMARILLO_(BZYE)",
  "MBYE": "AMARILLO_(MBYE)",
  "POSL": "ROSADO_(POSL)",
  "TRSP": "ROSADO_(TRSP)",
  "WBSU": "ROSADO_(WBSU)",
  "BTWI": "BLANCO_(BTWI)",
  "FBTX": "AMARILLO_(FBTX)",
  "SFBT": "AMARILLO_(SFBT)",
  "UBTX": "NEUTRO_(UBTX)",
  "WPBX": "AMARILLO_(WPBX)",
  "ASDM": "MORADO_(ASDM)",
  "CUDM": "MORADO_(CUDM)",
  "STDX": "MORADO_(STDX)",
  "CBPL": "MORADO_(CBPL)",
  "FXMR": "ROJO_(FXMR)",
  "LIMK": "ROSADO_(LIMK)",
  "MAPK": "ROSADO_(MAPK)",
  "RMPI": "ROSADO_(RMPI)",
  "SKMA": "ROSADO_(SKMA)",
  "LIML": "CAFE_(LIML)",
  "OMBN": "CAFE_(OMBN)",
  "EPNG": "VERDE_(EPNG)",
  "FIPN": "VERDE_(FIPN)",
  "GPNG": "VERDE_(GPNG)",
  "MPGN": "VERDE_(MPGN)",
  "PNGX": "VERDE_(PNGX)",
  "PSNE": "VERDE_(PSNE)",
  "SKPG": "VERDE_(SKPG)",
  "WHGN": "VERDE_(WHGN)",
  "BARB": "CAFE_(BARB)",
  "CRTB": "CAFE_(CRTB)",
  "SNRB": "CAFE_(SNRB)",
  "SWBN": "CAFE_(SWBN)",
  "PSRL": "ROJO_(PSRL)",
  "BDRL": "ROJO_(BDRL)",
  "FXRL": "ROJO_(FXRL)",
  "HSRL": "ROJO_(HSRL)",
  "MRTL": "ROJO_(MRTL)",
  "RMLR": "ROJO_(RMLR)",
  "SLRT": "ROJO_(SLRT)",
  "SPRX": "ROJO_(SPRX)",
  "CSDX": "GRIS_(CSDX)",
  "FTSD": "GRIS_(FTSD)",
  "FTSX": "GRIS_(FTSX)",
  "HSGR": "GRIS_(HSGR)",
  "SDLX": "GRIS_(SDLX)",
  "SGRX": "GRIS_(SGRX)",
  "SKGR": "GRIS_(SKGR)",
  "VLSG": "GRIS_(VLSG)",
  "WKLG": "GRIS_(WKLG)",
  "DPSN": "CAFE_(DPSN)",
  "HCBN": "CAFE_(HCBN)",
  "SBLS": "CAFE_(SBLS)",
  "SKBR": "CAFE_(SKBR)",
  "DSMA": "MORADO_(DSMA)",
  "FLSM": "MORADO_(FLSM)",
  "FRMV": "MORADO_(FRMV)",
  "LISM": "MORADO_(LISM)",
  "SMVX": "MORADO_(SMVX)",
  "UFMX": "MORADO_(UFMX)",
  "CTNX": "VERDE_(CTNX)",
  "OELT": "VERDE_(OELT)",
  "PLTN": "VERDE_(PLTN)",
  "SDGX": "VERDE_(SDGX)",
  "SHGN": "VERDE_(SHGN)",
  "TRNX": "VERDE_(TRNX)",
  "WITG": "VERDE_(WITG)",
  "BATB": "AZUL_(BATB)",
  "BTLX": "AZUL_(BTLX)",
  "CTLX": "AZUL_(CTLX)",
  "CTMB": "AZUL_(CTMB)",
  "FFTL": "AZUL_(FFTL)",
  "FSTM": "AZUL_(FSTM)",
  "FTHX": "AZUL_(FTHX)",
  "FTTX": "AZUL_(FTTX)",
  "FZTL": "AZUL_(FZTL)",
  "LYTL": "AZUL_(LYTL)",
  "SDTX": "AZUL_(SDTX)",
  "SETL": "AZUL_(SETL)",
  "SKTX": "AZUL_(SKTX)",
  "SNTL": "AZUL_(SNTL)",
  "STTL": "AZUL_(STTL)",
  "TMBX": "AZUL_(TMBX)",
  "TRBE": "AZUL_(TRBE)",
  "WPTL": "AZUL_(WPTL)",
  "ECTG": "VERDE_(ECTG)",
  "TLGN": "VERDE_(TLGN)",
  "ADNA": "AZUL_(ADNA)",
  "BCNA": "AZUL_(BCNA)",
  "CSNA": "AZUL_(CSNA)",
  "FLNA": "AZUL_(FLNA)",
  "LINV": "AZUL_(LINV)",
  "SFLN": "AZUL_(SFLN)",
  "SFNA": "AZUL_(SFNA)",
  "UFNA": "AZUL_(UFNA)",
  "WGNA": "AZUL_(WGNA)",
  "WWNN": "AZUL_(WWNN)",
  "FAEB": "AZUL_(FAEB)",
  "FFEN": "AZUL_(FFEN)",
  "PSEL": "AZUL_(PSEL)",
  "SREL": "AZUL_(SREL)",
  "WPLE": "AZUL_(WPLE)",
  "DSVL": "AZUL_(DSVL)",
  "FNVL": "AZUL_(FNVL)",
  "DMBL": "NEGRO_(DMBL)",
  "DTBL": "NEGRO_(DTBL)",
  "FFBK": "NEGRO_(FFBK)",
  "STBK": "NEGRO_(STBK)",
  "WDBL": "NEGRO_(WDBL)",
  "APIB": "NEGRO_(APIB)",
  "WMIB": "NEGRO_(WMIB)",
  "WPIB": "NEGRO_(WPIB)",
  "ASBE": "AZUL_(ASBE)",
  "CLSM": "AZUL_(CLSM)",
  "DASM": "AZUL_(DASM)",
  "HSMB": "AZUL_(HSMB)",
  "SFLB": "AZUL_(SFLB)",
  "STEX": "AZUL_(STEX)",
  "SWBE": "AZUL_(SWBE)",
  "SYBL": "AZUL_(SYBL)",
  "TSMB": "AZUL_(TSMB)",
  "WMBL": "AZUL_(WMBL)",
  "ASPH": "AZUL_(ASPH)",
  "SCPH": "AZUL_(SCPH)",
  "FCGN": "VERDE_(FCGN)",
  "HGCO": "VERDE_(HGCO)",
  "ODCO": "VERDE_(ODCO)",
  "CUFG": "GRIS_(CUFG)",
  "ILFO": "GRIS_(ILFO)",
  "SRFY": "GRIS_(SRFY)",
  "SRGY": "GRIS_(SRGY)",
  "PSTP": "MORADO_(PSTP)",
  "CABN": "VERDE_(CABN)",
  "FTGR": "VERDE_(FTGR)",
  "NVLX": "VERDE_(NVLX)",
  "SKNX": "VERDE_(SKNX)",
  "TLNX": "VERDE_(TLNX)",
  "DNBL": "AZUL_(DNBL)",
  "PLBU": "AZUL_(PLBU)",
  "SNYU": "AZUL_(SNYU)",
  "SSLU": "AZUL_(SSLU)",
  "CLTB": "CAFE_(CLTB)",
  "TLCN": "NEUTRO_(TLCN)",
  "BCRD": "ROJO_(BCRD)",
  "CARD": "ROJO_(CARD)",
  "INBU": "ROJO_(INBU)",
  "PSBU": "ROJO_(PSBU)",
  "SHPG": "CAFE_(SHPG)",
  "WGBN": "CAFE_(WGBN)",
  "BTEX": "ROSADO_(BTEX)",
  "FLTA": "ROSADO_(FLTA)",
  "ADPG": "AMARILLO_(ADPG)",
  "OGLC": "GRIS_(OGLC)",
  "OENL": "NEUTRO_(OENL)",
  "WDNL": "BLANCO_(WDNL)",
  "LIPH": "VERDE_(LIPH)",
  "SDPX": "NEUTRO_(SDPX)",
  "SEPX": "NEUTRO_(SEPX)",
  "TLPX": "NEUTRO_(TLPX)",
  "CBWI": "BLANCO_(CBWI)",
  "CHBW": "BLANCO_(CHBW)",
  "EVBI": "VERDE_(EVBI)",
  "FIBW": "BLANCO_(FIBW)",
  "OGLB": "BLANCO_(OGLB)",
  "PLBI": "BLANCO_(PLBI)",
  "TLBG": "CAFE_(TLBG)",
  "TRBI": "BLANCO_(TRBI)",
  "CHNL": "NEUTRO_(CHNL)",
  "SCNL": "NEUTRO_(SCNL)",
  "SRNL": "BLANCO_(SRNL)",
  "SYNL": "NEUTRO_(SYNL)",
  "WPLW": "BLANCO_(WPLW)",
  "BKGX": "VERDE_(BKGX)",
  "WPCC": "VERDE_(WPCC)",
  "MILX": "MORADO_(MILX)",
  "SNYX": "CAFE_(SNYX)",
  "SBTX": "AZUL_(SBTX)",
  "FSTI": "AZUL_(FSTI)",
  "BCHU": "AZUL_(BCHU)",
  "FLCU": "AZUL_(FLCU)",
  "UTBX": "AZUL_(UTBX)",
  "WGNX": "VERDE_(WGNX)",
  "DILP": "GRIS_(DILP)",
  "HILP": "GRIS_(HILP)",
  "SKAP": "ROSADO_(SKAP)",
  "SMTP": "ROSADO_(SMTP)",
  "FXBI": "BLANCO_(FXBI)",
  "LRBI": "BLANCO_(LRBI)",
  "RLBI": "BLANCO_(RLBI)",
  "SKBH": "BLANCO_(SKBH)",
  "WPBI": "BLANCO_(WPBI)",
  "MGBL": "NEGRO_(MGBL)",
  "SKBN": "VERDE_(SKBN)",
  "CHBX": "VERDE_(CHBX)",
  "FFBU": "VERDE_(FFBU)",
  "SDBG": "VERDE_(SDBG)",
  "TLBX": "VERDE_(TLBX)",
  "SHPB": "AZUL_(SHPB)",
  "SKCB": "AZUL_(SKCB)",
  "BSLC": "AZUL_(BSLC)",
  "SGTN": "NEUTRO_(SGTN)",
  "SHPT": "NEUTRO_(SHPT)",
  "WPTN": "NEUTRO_(WPTN)",
  "PLCO": "ROSADO_(PLCO)",
  "PLCC": "ROSADO_(PLCC)",
  "PMCX": "ROJO_(PMCX)",
  "ALCO": "VERDE_(ALCO)",
  "CLGN": "VERDE_(CLGN)",
  "CWGN": "VERDE_(CWGN)",
  "FSCG": "VERDE_(FSCG)",
  "GPCC": "VERDE_(GPCC)",
  "WPCO": "VERDE_(WPCO)",
  "WLCO": "VERDE_(WLCO)",
  "ALEB": "AZUL_(ALEB)",
  "CENB": "AZUL_(CENB)",
  "CEBL": "AZUL_(CEBL)",
  "SKEL": "AZUL_(SKEL)",
  "WGEN": "AZUL_(WGEN)",
  "CHFY": "GRIS_(CHFY)",
  "FZFT": "GRIS_(FZFT)",
  "FHY": "GRIS_(FHY)",
  "GSFY": "GRIS_(GSFY)",
  "SGFY": "GRIS_(SGFY)",
  "ANFO": "GRIS_(ANFO)",
  "FMSG": "GRIS_(FMSG)",
  "HGFO": "GRIS_(HGFO)",
  "KAFG": "GRIS_(KAFG)",
  "CBGA": "VERDE_(CBGA)",
  "ERGA": "VERDE_(ERGA)",
  "LGGN": "VERDE_(LGGN)",
  "TLGA": "VERDE_(TLGA)",
  "WPGN": "VERDE_(WPGN)",
  "WPGA": "VERDE_(WPGA)",
  "UFGL": "AZUL_(UFGL)",
  "POLG": "CAFE_(POLG)",
  "SGBN": "CAFE_(SGBN)",
  "TLGB": "CAFE_(TLGB)",
  "UGBN": "CAFE_(UGBN)",
  "UFGN": "AZUL_(UFGN)",
  "CWHE": "GRIS_(CWHE)",
  "DIBK": "NEGRO_(DIBK)",
  "FLBK": "NEGRO_(FLBK)",
  "FMIB": "NEGRO_(FMIB)",
  "HTIB": "NEGRO_(HTIB)",
  "LIBK": "NEGRO_(LIBK)",
  "UFIB": "NEGRO_(UFIB)",
  "UTIB": "NEGRO_(UTIB)",
  "SBLM": "AZUL_(SBLM)",
  "BHMA": "ROJO_(BHMA)",
  "LIMR": "ROJO_(LIMR)",
  "SHPM": "VERDE_(SHPM)",
  "BTMX": "MORADO_(BTMX)",
  "CSMA": "MORADO_(CSMA)",
  "CMAX": "MORADO_(CMAX)",
  "ISMA": "MORADO_(ISMA)",
  "ISDM": "MORADO_(ISDM)",
  "RMMA": "MORADO_(RMMA)",
  "LIMD": "AMARILLO_(LIMD)",
  "SEMY": "AMARILLO_(SEMY)",
  "ALNA": "BLANCO_(ALNA)",
  "CSNL": "BLANCO_(CSNL)",
  "CWNL": "BLANCO_(CWNL)",
  "GCNY": "AZUL_(GCNY)",
  "NVNY": "AZUL_(NVNY)",
  "RLNA": "AZUL_(RLNA)",
  "SKNU": "VERDE_(SKNU)",
  "LYNO": "VERDE_(LYNO)",
  "SLNG": "VERDE_(SLNG)",
  "UFZN": "VERDE_(UFZN)",
  "SHPO": "CAFE_(SHPO)",
  "CITN": "NEUTRO_(CITN)",
  "WWTN": "CAFE_(WWTN)",
  "FZPE": "ROSADO_(FZPE)",
  "FRPL": "ROSADO_(FRPL)",
  "SPGX": "VERDE_(SPGX)",
  "CHPX": "VERDE_(CHPX)",
  "GSPX": "ROJO_(GSPX)",
  "UPMX": "ROJO_(UPMX)",
  "CFPU": "AMARILLO_(CFPU)",
  "CLPG": "AMARILLO_(CLPG)",
  "DIPG": "AMARILLO_(DIPG)",
  "FSPD": "AMARILLO_(FSPD)",
  "STPD": "AMARILLO_(STPD)",
  "SNPG": "AMARILLO_(SNPG)",
  "SPFX": "AMARILLO_(SPFX)",
  "WPGX": "AMARILLO_(WPGX)",
  "WLPU": "AMARILLO_(WLPU)",
  "SKPU": "NEUTRO_(SKPU)",
  "CTPX": "NEUTRO_(CTPX)",
  "FPMX": "NEUTRO_(FPMX)",
  "JKPU": "NEUTRO_(JKPU)",
  "LIPM": "NEUTRO_(LIPM)",
  "LIPU": "NEUTRO_(LIPU)",
  "LYPE": "BLANCO_(LYPE)",
  "LYPU": "BLANCO_(LYPU)",
  "RPMX": "NEUTRO_(RPMX)",
  "SMPU": "NEUTRO_(SMPU)",
  "UFPX": "NEUTRO_(UFPX)",
  "SKLG": "VERDE_(SKLG)",
  "BLSA": "VERDE_(BLSA)",
  "FLSN": "VERDE_(FLSN)",
  "HGSA": "VERDE_(HGSA)",
  "HGSS": "VERDE_(HGSS)",
  "BDSA": "NARANJO_(BDSA)",
  "BSMX": "NARANJO_(BSMX)",
  "CLMX": "NARANJO_(CLMX)",
  "SKLY": "CAFE_(SKLY)",
  "AMSI": "CAFE_(AMSI)",
  "CISC": "CAFE_(CISC)",
  "DSNX": "CAFE_(DSNX)",
  "GCSI": "CAFE_(GCSI)",
  "HTSI": "CAFE_(HTSI)",
  "LYSI": "CAFE_(LYSI)",
  "NVSI": "CAFE_(NVSI)",
  "PHSI": "CAFE_(PHSI)",
  "SKCY": "CAFE_(SKCY)",
  "SMTS": "CAFE_(SMTS)",
  "WISC": "CAFE_(WISC)",
  "SKSM": "AZUL_(SKSM)",
  "CISM": "AZUL_(CISM)",
  "WWSB": "AZUL_(WWSB)",
  "SSLX": "AZUL_(SSLX)",
  "CISL": "AZUL_(CISL)",
  "KASL": "AZUL_(KASL)",
  "ONSL": "AZUL_(ONSL)",
  "SSLB": "AZUL_(SSLB)",
  "TRSL": "AZUL_(TRSL)",
  "TLSX": "AZUL_(TLSX)",
  "UFSL": "AZUL_(UFSL)",
  "UFSX": "AZUL_(UFSX)",
  "CTLG": "GRIS_(CTLG)",
  "FXTA": "GRIS_(FXTA)",
  "RWTG": "GRIS_(RWTG)",
  "HTTL": "CAFE_(HTTL)",
  "CUDL": "NEUTRO_(CUDL)",
  "FANL": "NEUTRO_(FANL)",
  "WPNL": "NEUTRO_(WPNL)",
  "SKUX": "AZUL_(SKUX)",
  "BLUX": "AZUL_(BLUX)",
  "CBLU": "AZUL_(CBLU)",
  "CWUE": "AZUL_(CWUE)",
  "CLDU": "AZUL_(CLDU)",
  "FMUE": "AZUL_(FMUE)",
  "PPHU": "AZUL_(PPHU)",
  "TKAU": "AZUL_(TKAU)",
  "TLUE": "AZUL_(TLUE)",
  "TINU": "AZUL_(TINU)",
  "TRUX": "AZUL_(TRUX)",
  "UFZU": "AZUL_(UFZU)",
  "WHUE": "AZUL_(WHUE)",
  "WIUT": "AZUL_(WIUT)",
  "AMVL": "AZUL_(AMVL)",
  "CIVL": "AZUL_(CIVL)",
  "CLVX": "AZUL_(CLVX)",
  "FLVE": "AZUL_(FLVE)",
  "MIVL": "AZUL_(MIVL)",
  "OGVL": "AZUL_(OGVL)",
  "POLV": "AZUL_(POLV)",
  "RVLX": "AZUL_(RVLX)",
  "UFVL": "AZUL_(UFVL)",
  "WPVB": "AZUL_(WPVB)",
  "WPVL": "AZUL_(WPVL)",
  "WPVE": "AZUL_(WPVE)",
  "POLW": "ROSADO_(POLW)",
  "RMWT": "BLANCO_(RMWT)",
  "UFWI": "BLANCO_(UFWI)",
  "AIWG": "VERDE_(AIWG)",
  "BLWG": "VERDE_(BLWG)",
  "CWWI": "VERDE_(CWWI)",
  "DWNX": "VERDE_(DWNX)",
  "EPWI": "VERDE_(EPWI)",
  "FTWX": "VERDE_(FTWX)",
  "PSWI": "VERDE_(PSWI)",
  "SBWG": "VERDE_(SBWG)",
  "SHWI": "VERDE_(SHWI)",
  "CNVY": "AZUL_(CNVY)",
  "CPNY": "AZUL_(CPNY)",
  "FINN": "AZUL_(FINN)",
  "MPNA": "AZUL_(MPNA)",
  "PKNY": "AZUL_(PKNY)",
  "VINY": "AZUL_(VINY)",
  "GDSU": "AZUL_(GDSU)",
  "FMCL": "AZUL_(FMCL)",
  "FPLA": "AZUL_(FPLA)",
  "LTBX": "AZUL_(LTBX)",
  "CLBI": "NEGRO_(CLBI)",
  "FPBL": "NEGRO_(FPBL)",
  "RSMI": "NEGRO_(RSMI)",
  "TLIB": "NEGRO_(TLIB)",
  "WGBL": "NEGRO_(WGBL)",
  "RIDN": "VERDE_(RIDN)",
  "ICBE": "AZUL_(ICBE)",
  "MTBL": "AZUL_(MTBL)",
  "SLPH": "AZUL_(SLPH)",
  "THBL": "AZUL_(THBL)",
  "BAGN": "VERDE_(BAGN)",
  "WILG": "VERDE_(WILG)",
  "TLNG": "VERDE_(TLNG)",
  "AVNU": "VERDE_(AVNU)",
  "BPNU": "VERDE_(BPNU)",
  "CHNG": "VERDE_(CHNG)",
  "FGNU": "VERDE_(FGNU)",
  "FHNU": "VERDE_(FHNU)",
  "FING": "VERDE_(FING)",
  "FPNU": "VERDE_(FPNU)",
  "GDNU": "VERDE_(GDNU)",
  "GLNU": "VERDE_(GLNU)",
  "PLNU": "VERDE_(PLNU)",
  "PPNU": "VERDE_(PPNU)",
  "RING": "VERDE_(RING)",
  "SNNU": "VERDE_(SNNU)",
  "WENU": "VERDE_(WENU)",
  "NGRX": "VERDE_(NGRX)",
  "CFGN": "VERDE_(CFGN)",
  "SKTL": "CAFE_(SKTL)",
  "CFLP": "GRIS_(CFLP)",
  "GLGA": "VERDE_(GLGA)",
  "TLMO": "NEUTRO_(TLMO)",
  "STMX": "AZUL_(STMX)",
  "SPTN": "CAFE_(SPTN)",
  "VSTA": "NEUTRO_(VSTA)",
  "DMPI": "ROSADO_(DMPI)",
  "FAPI": "ROSADO_(FAPI)",
  "GLNT": "BLANCO_(GLNT)",
  "MFLN": "NEUTRO_(MFLN)",
  "SNDA": "BLANCO_(SNDA)",
  "FHBI": "BLANCO_(FHBI)",
  "RBIW": "BLANCO_(RBIW)",
  "REBI": "BLANCO_(REBI)",
  "SNBH": "BLANCO_(SNBH)",
  "FINL": "NEUTRO_(FINL)",
  "FPNL": "NEUTRO_(FPNL)",
  "PNNL": "NEUTRO_(PNNL)",
  "SENL": "BLANCO_(SENL)",
  "SNNL": "BLANCO_(SNNL)",
  "FGWI": "BLANCO_(FGWI)",
  "FZHE": "BLANCO_(FZHE)",
  "WILW": "BLANCO_(WILW)",
  "HMDO": "AZUL_(HMDO)",
  "LVFN": "CAFE_(LVFN)",
  "OGLF": "VERDE_(OGLF)",
  "CPBL": "AZUL_(CPBL)",
  "FLBY": "AZUL_(FLBY)",
  "FPBE": "AZUL_(FPBE)",
  "ICBY": "AZUL_(ICBY)",
  "LVBE": "AZUL_(LVBE)",
  "PNBY": "AZUL_(PNBY)",
  "REBL": "AZUL_(REBL)",
  "BBLX": "AZUL_(BBLX)",
  "FBYX": "AZUL_(FBYX)",
  "TTBX": "AZUL_(TTBX)",
  "BLYX": "AZUL_(BLYX)",
  "ANBD": "AZUL_(ANBD)",
  "AVBI": "AZUL_(AVBI)",
  "CWBL": "AZUL_(CWBL)",
  "GFBI": "AZUL_(GFBI)",
  "LVBI": "AZUL_(LVBI)",
  "FUBR": "ROJO_(FUBR)",
  "ICRD": "ROJO_(ICRD)",
  "PBLR": "ROJO_(PBLR)",
  "PKRE": "ROJO_(PKRE)",
  "RIBD": "ROJO_(RIBD)",
  "RMBU": "ROJO_(RMBU)",
  "SCRD": "ROJO_(SCRD)",
  "SKBU": "ROJO_(SKBU)",
  "VIBL": "ROJO_(VIBL)",
  "WIBD": "ROJO_(WIBD)",
  "SYRX": "ROJO_(SYRX)",
  "BLRX": "ROJO_(BLRX)",
  "SKCE": "ROJO_(SKCE)",
  "LBCO": "AMARILLO_(LBCO)",
  "SYGD": "AMARILLO_(SYGD)",
  "CPEX": "NARANJO_(CPEX)",
  "FEPX": "NARANJO_(FEPX)",
  "CPHX": "NARANJO_(CPHX)",
  "FHMA": "NARANJO_(FHMA)",
  "FHMO": "NARANJO_(FHMO)",
  "GDMA": "NARANJO_(GDMA)",
  "PILM": "NARANJO_(PILM)",
  "PKMA": "AMARILLO_(PKMA)",
  "RSDM": "NARANJO_(RSDM)",
  "SUGN": "CAFE_(SUGN)",
  "FRMY": "MORADO_(FRMY)",
  "FLNP": "MORADO_(FLNP)",
  "FPNI": "MORADO_(FPNI)",
  "GLNI": "MORADO_(GLNI)",
  "PKNI": "MORADO_(PKNI)",
  "ZNPL": "MORADO_(ZNPL)",
  "NTPX": "MORADO_(NTPX)",
  "SNPL": "MORADO_(SNPL)",
  "AFPE": "MORADO_(AFPE)",
  "SNPE": "MORADO_(SNPE)",
  "FNPX": "MORADO_(FNPX)",
  "RMPX": "MORADO_(RMPX)",
  "FABE": "AZUL_(FABE)",
  "LFPA": "AZUL_(LFPA)",
  "GFPL": "ROSADO_(GFPL)",
  "MAPL": "ROSADO_(MAPL)",
  "FASK": "AZUL_(FASK)",
  "FINF": "AZUL_(FINF)",
  "FRAS": "AZUL_(FRAS)",
  "HSLB": "AZUL_(HSLB)",
  "RMBL": "AZUL_(RMBL)",
  "RESL": "VERDE_(RESL)",
  "RMSL": "VERDE_(RMSL)",
  "TLVG": "VERDE_(TLVG)",
  "WGSL": "VERDE_(WGSL)",
  "WWSL": "VERDE_(WWSL)",
  "FINX": "VERDE_(FINX)",
  "LNGX": "VERDE_(LNGX)",
  "MLNX": "VERDE_(MLNX)",
  "SNGX": "VERDE_(SNGX)",
  "TRGX": "VERDE_(TRGX)",
  "STGX": "VERDE_(STGX)",
  "FHRE": "ROJO_(FHRE)",
  "ABEA": "AZUL_(ABEA)",
  "ABWI": "BLANCO_(ABWI)",
  "FPBA": "AZUL_(FPBA)",
  "HJBA": "AZUL_(HJBA)",
  "TPCO": "CAFE_(TPCO)",
  "JYFO": "GRIS_(JYFO)",
  "WDFO": "GRIS_(WDFO)",
  "IHGN": "VERDE_(IHGN)",
  "PKHG": "VERDE_(PKHG)",
  "HGNX": "VERDE_(HGNX)",
  "FLYI": "NEGRO_(FLYI)",
  "PRIN": "NEGRO_(PRIN)",
  "PLYE": "AMARILLO_(PLYE)",
  "FRLA": "AZUL_(FRLA)",
  "FSLA": "AZUL_(FSLA)",
  "PRLA": "AZUL_(PRLA)",
  "TPLA": "AZUL_(TPLA)",
  "PLTB": "AZUL_(PLTB)",
  "LWPL": "GRIS_(LWPL)",
  "OVPL": "GRIS_(OVPL)",
  "RLPG": "GRIS_(RLPG)",
  "SSLP": "GRIS_(SSLP)",
  "LPBX": "GRIS_(LPBX)",
  "DRNA": "NEUTRO_(DRNA)",
  "CFNY": "AZUL_(CFNY)",
  "SMTN": "AZUL_(SMTN)",
  "RCOA": "NEUTRO_(RCOA)",
  "RITN": "CAFE_(RITN)",
  "TLOA": "NEUTRO_(TLOA)",
  "WIGT": "NEUTRO_(WIGT)",
  "LWWT": "BLANCO_(LWWT)",
  "JOYP": "AZUL_(JOYP)",
  "FLPG": "GRIS_(FLPG)",
  "JYPL": "GRIS_(JYPL)",
  "RIPU": "NEUTRO_(RIPU)",
  "FZPX": "NEUTRO_(FZPX)",
  "PDYX": "NEUTRO_(PDYX)",
  "FSSU": "ROSADO_(FSSU)",
  "PTSU": "ROSADO_(PTSU)",
  "FSSI": "CAFE_(FSSI)",
  "FRSA": "VERDE_(FRSA)",
  "RFBE": "AZUL_(RFBE)",
  "JOYS": "AZUL_(JOYS)",
  "DRST": "AZUL_(DRST)",
  "EIBL": "AZUL_(EIBL)",
  "LFSM": "AZUL_(LFSM)",
  "FTBX": "AZUL_(FTBX)",
  "LFBX": "AZUL_(LFBX)",
  "SSMX": "AZUL_(SSMX)",
  "USBX": "AZUL_(USBX)",
  "CHMA": "MORADO_(CHMA)",
  "ABSD": "AMARILLO_(ABSD)",
  "FLSU": "AMARILLO_(FLSU)",
  "GPSW": "AMARILLO_(GPSW)",
  "SMTY": "AMARILLO_(SMTY)",
  "SPDY": "AMARILLO_(SPDY)",
  "TRYE": "AMARILLO_(TRYE)",
  "BOYX": "AMARILLO_(BOYX)",
  "GPYT": "AZUL_(GPYT)",
  "TAGB": "AZUL_(TAGB)",
  "BYTL": "AZUL_(BYTL)",
  "FLTI": "AZUL_(FLTI)",
  "LFTI": "AZUL_(LFTI)",
  "SQTI": "AZUL_(SQTI)",
  "LFUN": "NEUTRO_(LFUN)",
  "SKLU": "NEUTRO_(SKLU)",
  "LFWA": "AZUL_(LFWA)",
  "DRWI": "BLANCO_(DRWI)",
  "SMRW": "BLANCO_(SMRW)",
  "ABMA": "MORADO_(ABMA)",
  "CYEM": "MORADO_(CYEM)",
  "FFEM": "ROSADO_(FFEM)",
  "GTMA": "MORADO_(GTMA)",
  "IHMA": "MORADO_(IHMA)",
  "JYEM": "MORADO_(JYEM)",
  "SQMA": "MORADO_(SQMA)",
  "SZEM": "MORADO_(SZEM)",
  "BEMX": "MORADO_(BEMX)",
  "EMAX": "MORADO_(EMAX)",
  "JOYL": "AZUL_(JOYL)",
  "SMRY": "AMARILLO_(SMRY)",
  "DYSA": "VERDE_(DYSA)",
  "JOYG": "VERDE_(JOYG)",
  "LFGN": "VERDE_(LFGN)",
  "PYGN": "VERDE_(PYGN)",
  "RFSG": "VERDE_(RFSG)",
  "VOSG": "VERDE_(VOSG)",
  "LSGX": "VERDE_(LSGX)",
  "SGNX": "VERDE_(SGNX)",
  "TTPB": "CAFE_(TTPB)",
  "TRBX": "CAFE_(TRBX)",
  "PLPI": "ROSADO_(PLPI)",
  "CYDP": "MORADO_(CYDP)",
  "PLDN": "MORADO_(PLDN)",
  "IHPE": "MORADO_(IHPE)",
  "JYPE": "MORADO_(JYPE)",
  "FIQL": "NARANJO_(FIQL)",
  "PTCL": "ROSADO_(PTCL)",
  "TRCO": "ROSADO_(TRCO)",
  "QUCX": "ROSADO_(QUCX)",
  "FHNE": "AZUL_(FHNE)",
  "FINE": "AZUL_(FINE)",
  "FMNA": "AZUL_(FMNA)",
  "NOLN": "AZUL_(NOLN)",
  "SPNA": "AZUL_(SPNA)",
  "TENE": "AZUL_(TENE)",
  "TLNE": "AZUL_(TLNE)",
  "CLSU": "AZUL_(CLSU)",
  "FFIN": "NEGRO_(FFIN)",
  "FIBK": "NEGRO_(FIBK)",
  "OWIK": "NEGRO_(OWIK)",
  "PLIN": "NEGRO_(PLIN)",
  "QUIB": "NEGRO_(QUIB)",
  "RIKB": "NEGRO_(RIKB)",
  "RMIN": "NEGRO_(RMIN)",
  "WABK": "NEGRO_(WABK)",
  "RAMB": "AZUL_(RAMB)",
  "ALTI": "AZUL_(ALTI)",
  "BETB": "AZUL_(BETB)",
  "CCTI": "AZUL_(CCTI)",
  "EVTI": "AZUL_(EVTI)",
  "WATL": "AZUL_(WATL)",
  "BEFG": "GRIS_(BEFG)",
  "FIFS": "GRIS_(FIFS)",
  "FIGY": "GRIS_(FIGY)",
  "FITL": "AZUL_(FITL)",
  "LGTL": "AZUL_(LGTL)",
  "TRET": "VERDE_(TRET)",
  "CBSG": "VERDE_(CBSG)",
  "CTBA": "VERDE_(CTBA)",
  "LIBA": "VERDE_(LIBA)",
  "PEBN": "VERDE_(PEBN)",
  "TEBG": "VERDE_(TEBG)",
  "WIGN": "VERDE_(WIGN)",
  "CMKC": "AZUL_(CMKC)",
  "JECB": "AZUL_(JECB)",
  "SCBX": "AZUL_(SCBX)",
  "CLHG": "VERDE_(CLHG)",
  "FYHG": "VERDE_(FYHG)",
  "LOHG": "VERDE_(LOHG)",
  "FORG": "GRIS_(FORG)",
  "WIGG": "GRIS_(WIGG)",
  "NOGX": "GRIS_(NOGX)",
  "OLFX": "ROJO_(OLFX)",
  "CMKD": "CAFE_(CMKD)",
  "LIDY": "CAFE_(LIDY)",
  "DILG": "AZUL_(DILG)",
  "FLGY": "GRIS_(FLGY)",
  "SLPX": "GRIS_(SLPX)",
  "SNYP": "GRIS_(SNYP)",
  "SPLY": "GRIS_(SPLY)",
  "FEGX": "GRIS_(FEGX)",
  "EVWX": "ROJO_(EVWX)",
  "FIWR": "ROJO_(FIWR)",
  "SLRX": "ROJO_(SLRX)",
  "PLRU": "MORADO_(PLRU)",
  "CMKG": "VERDE_(CMKG)",
  "PLGA": "VERDE_(PLGA)",
  "SPGA": "VERDE_(SPGA)",
  "RAMW": "CAFE_(RAMW)",
  "SKTA": "CAFE_(SKTA)",
  "DISB": "AZUL_(DISB)",
  "FISI": "CAFE_(FISI)",
  "GTSI": "CAFE_(GTSI)",
  "MBSU": "CAFE_(MBSU)",
  "MFSI": "CAFE_(MFSI)",
  "SBNX": "CAFE_(SBNX)",
  "SBRX": "CAFE_(SBRX)",
  "SDTN": "CAFE_(SDTN)",
  "TESU": "CAFE_(TESU)",
  "TPSI": "CAFE_(TPSI)",
  "UPSI": "CAFE_(UPSI)",
  "WASN": "ROJO_(WASN)",
  "FORM": "CAFE_(FORM)",
  "FMRU": "CAFE_(FMRU)",
  "SMKA": "CAFE_(SMKA)",
  "FIPI": "ROSADO_(FIPI)",
  "PHLS": "ROSADO_(PHLS)",
  "PLSR": "ROSADO_(PLSR)",
  "SLPI": "ROSADO_(SLPI)",
  "HZMO": "CAFE_(HZMO)",
  "LOTN": "CAFE_(LOTN)",
  "BFCA": "CAFE_(BFCA)",
  "PATS": "ROJO_(PATS)",
  "PLRD": "ROJO_(PLRD)",
  "RISU": "ROJO_(RISU)",
  "JEHG": "NARANJO_(JEHG)",
  "WADN": "NEUTRO_(WADN)",
  "WAPU": "NEUTRO_(WAPU)",
  "CCBI": "BLANCO_(CCBI)",
  "JBIW": "BLANCO_(JBIW)",
  "PALW": "BLANCO_(PALW)",
  "SPBI": "BLANCO_(SPBI)",
  "TEBI": "BLANCO_(TEBI)",
  "WLNA": "NEUTRO_(WLNA)",
  "WIGH": "GRIS_(WIGH)",
  "BLWI": "BLANCO_(BLWI)",
  "FIOW": "BLANCO_(FIOW)",
  "FLWI": "BLANCO_(FLWI)",
  "ISLW": "BLANCO_(ISLW)",
  "CCAB": "AMARILLO_(CCAB)",
  "CGDX": "AMARILLO_(CGDX)",
  "FIGO": "AMARILLO_(FIGO)",
  "FPGO": "AMARILLO_(FPGO)",
  "LNCA": "AMARILLO_(LNCA)",
  "SLGO": "AMARILLO_(SLGO)",
  "TECB": "AMARILLO_(TECB)",
  "LICO": "CAFE_(LICO)",
  "FFOA": "BLANCO_(FFOA)",
  "JFOA": "BLANCO_(JFOA)",
  "TREO": "NEUTRO_(TREO)",
  "BAPB": "AZUL_(BAPB)",
  "FPIB": "AZUL_(FPIB)",
  "LVPI": "AZUL_(LVPI)",
  "PKPI": "AZUL_(PKPI)",
  "WAPH": "AZUL_(WAPH)",
  "WAPI": "AZUL_(WAPI)",
  "CCPI": "VERDE_(CCPI)",
  "GIPI": "VERDE_(GIPI)",
  "JFPG": "VERDE_(JFPG)",
  "LIPN": "VERDE_(LIPN)",
  "LSYP": "VERDE_(LSYP)",
  "SKPX": "VERDE_(SKPX)",
  "SNPI": "VERDE_(SNPI)",
  "CLSQ": "AZUL_(CLSQ)",
  "FLSE": "ROJO_(FLSE)",
  "LOSQ": "ROJO_(LOSQ)",
  "MUSR": "ROJO_(MUSR)",
  "CTSO": "AZUL_(CTSO)",
  "LGSD": "AZUL_(LGSD)",
  "LGSO": "AZUL_(LGSO)",
  "SPSO": "AZUL_(SPSO)",
  "WASO": "AZUL_(WASO)",
  "PLSM": "AZUL_(PLSM)",
  "SBGX": "AZUL_(SBGX)",
  "WAST": "AZUL_(WAST)",
  "BEWY": "AZUL_(BEWY)",
  "BLWA": "AZUL_(BLWA)",
  "BLWX": "AZUL_(BLWX)",
  "EVWA": "AZUL_(EVWA)",
  "FIWB": "AZUL_(FIWB)",
  "FLWA": "AZUL_(FLWA)",
  "HWAX": "AZUL_(HWAX)",
  "LGWA": "AZUL_(LGWA)",
  "LOWA": "AZUL_(LOWA)",
  "MYMB": "AZUL_(MYMB)",
  "PEWA": "AZUL_(PEWA)",
  "PKWA": "AZUL_(PKWA)",
  "SSWE": "AZUL_(SSWE)",
  "WBLX": "AZUL_(WBLX)",
  "WTBX": "AZUL_(WTBX)",
  "BEWO": "BLANCO_(BEWO)",
  "BRWO": "BLANCO_(BRWO)",
  "MFWO": "BLANCO_(MFWO)",
  "SIWL": "BLANCO_(SIWL)",
  "CAWY": "VERDE_(CAWY)",
  "LIWG": "VERDE_(LIWG)",
  "CFAB": "AZUL_(CFAB)",
  "CPAA": "AZUL_(CPAA)",
  "DIMB": "AZUL_(DIMB)",
  "JHOA": "BLANCO_(JHOA)",
  "PABE": "AZUL_(PABE)",
  "ABTA": "AZUL_(ABTA)",
  "RIBA": "AZUL_(RIBA)",
  "WWAN": "AZUL_(WWAN)",
  "CBZW": "BLANCO_(CBZW)",
  "CFBI": "BLANCO_(CFBI)",
  "EWBI": "BLANCO_(EWBI)",
  "FABI": "BLANCO_(FABI)",
  "FMBI": "BLANCO_(FMBI)",
  "FTBI": "GRIS_(FTBI)",
  "HOBW": "BLANCO_(HOBW)",
  "JEBW": "BLANCO_(JEBW)",
  "ORBI": "BLANCO_(ORBI)",
  "REBW": "BLANCO_(REBW)",
  "RSBI": "BLANCO_(RSBI)",
  "TFBI": "BLANCO_(TFBI)",
  "TSAW": "BLANCO_(TSAW)",
  "AIBK": "NEGRO_(AIBK)",
  "DOBK": "NEGRO_(DOBK)",
  "ROBL": "NEGRO_(ROBL)",
  "REBG": "VERDE_(REBG)",
  "LCCA": "ROSADO_(LCCA)",
  "LSBC": "ROSADO_(LSBC)",
  "CLOW": "NARANJO_(CLOW)",
  "AICC": "ROSADO_(AICC)",
  "BGCO": "ROSADO_(BGCO)",
  "FZCO": "ROSADO_(FZCO)",
  "RSCO": "ROSADO_(RSCO)",
  "BBCO": "ROSADO_(BBCO)",
  "LURC": "ROSADO_(LURC)",
  "CRCY": "ROSADO_(CRCY)",
  "CTDX": "AZUL_(CTDX)",
  "HSCU": "AZUL_(HSCU)",
  "LYBE": "AZUL_(LYBE)",
  "MCEX": "AZUL_(MCEX)",
  "MFBL": "AZUL_(MFBL)",
  "RMCU": "AZUL_(RMCU)",
  "TECX": "AZUL_(TECX)",
  "TFCU": "AZUL_(TFCU)",
  "TPCU": "AZUL_(TPCU)",
  "TSCU": "AZUL_(TSCU)",
  "WWCU": "AZUL_(WWCU)",
  "DKBE": "CAFE_(DKBE)",
  "LYDB": "CAFE_(LYDB)",
  "AIWH": "BLANCO_(AIWH)",
  "FAMD": "BLANCO_(FAMD)",
  "FAWH": "BLANCO_(FAWH)",
  "BLAF": "GRIS_(BLAF)",
  "DOFX": "AZUL_(DOFX)",
  "FBWO": "AZUL_(FBWO)",
  "GPFI": "AZUL_(GPFI)",
  "HBFI": "AZUL_(HBFI)",
  "HFIX": "AZUL_(HFIX)",
  "IFBL": "AZUL_(IFBL)",
  "TTFI": "AZUL_(TTFI)",
  "HOFB": "AZUL_(HOFB)",
  "LSWB": "AZUL_(LSWB)",
  "MOFB": "AZUL_(MOFB)",
  "OJPF": "AZUL_(OJPF)",
  "QUBL": "AZUL_(QUBL)",
  "RIFX": "ROSADO_(RIFX)",
  "TIFX": "ROSADO_(TIFX)",
  "TOIP": "ROSADO_(TOIP)",
  "FRTX": "AZUL_(FRTX)",
  "HTIF": "AZUL_(HTIF)",
  "TEFX": "AZUL_(TEFX)",
  "CHGA": "VERDE_(CHGA)",
  "GGBI": "VERDE_(GGBI)",
  "GGHR": "VERDE_(GGHR)",
  "MFGA": "VERDE_(MFGA)",
  "YAGN": "VERDE_(YAGN)",
  "FSHE": "GRIS_(FSHE)",
  "AIHG": "AMARILLO_(AIHG)",
  "LCHA": "AMARILLO_(LCHA)",
  "FCIB": "AZUL_(FCIB)",
  "VODI": "AZUL_(VODI)",
  "CWIB": "NEGRO_(CWIB)",
  "IBBI": "NEGRO_(IBBI)",
  "NWIB": "NEGRO_(NWIB)",
  "OLBK": "NEGRO_(OLBK)",
  "SLIN": "NEGRO_(SLIN)",
  "TRIB": "NEGRO_(TRIB)",
  "AAIY": "AMARILLO_(AAIY)",
  "CAIY": "AMARILLO_(CAIY)",
  "CSIY": "AMARILLO_(CSIY)",
  "LCYE": "AMARILLO_(LCYE)",
  "OJPY": "AMARILLO_(OJPY)",
  "PAIY": "AMARILLO_(PAIY)",
  "PLWY": "AMARILLO_(PLWY)",
  "SOIY": "AMARILLO_(SOIY)",
  "BBLA": "AZUL_(BBLA)",
  "CPLA": "AZUL_(CPLA)",
  "FLBE": "AZUL_(FLBE)",
  "FTLA": "AZUL_(FTLA)",
  "HOLB": "AZUL_(HOLB)",
  "FASC": "AZUL_(FASC)",
  "FMDG": "VERDE_(FMDG)",
  "MEGN": "VERDE_(MEGN)",
  "RLGN": "VERDE_(RLGN)",
  "ABLG": "GRIS_(ABLG)",
  "AGLP": "GRIS_(AGLP)",
  "AIPG": "GRIS_(AIPG)",
  "AMPG": "GRIS_(AMPG)",
  "ASLP": "VERDE_(ASLP)",
  "ATPG": "GRIS_(ATPG)",
  "BLPX": "GRIS_(BLPX)",
  "BOPX": "GRIS_(BOPX)",
  "FPGY": "GRIS_(FPGY)",
  "HOPX": "GRIS_(HOPX)",
  "LIGB": "GRIS_(LIGB)",
  "LIPX": "GRIS_(LIPX)",
  "MUPG": "GRIS_(MUPG)",
  "RCGY": "GRIS_(RCGY)",
  "RILP": "GRIS_(RILP)",
  "SCLI": "GRIS_(SCLI)",
  "SLPG": "GRIS_(SLPG)",
  "SOLG": "GRIS_(SOLG)",
  "TELG": "GRIS_(TELG)",
  "TELP": "GRIS_(TELP)",
  "WCGY": "GRIS_(WCGY)",
  "FRMO": "NEUTRO_(FRMO)",
  "FTMO": "NEUTRO_(FTMO)",
  "FWMO": "CAFE_(FWMO)",
  "RCMI": "NEUTRO_(RCMI)",
  "WHKI": "CAFE_(WHKI)",
  "AIMP": "MORADO_(AIMP)",
  "CBZN": "AZUL_(CBZN)",
  "FMNY": "AZUL_(FMNY)",
  "HANX": "AZUL_(HANX)",
  "LMNN": "AZUL_(LMNN)",
  "NEWI": "AZUL_(NEWI)",
  "RCNA": "AZUL_(RCNA)",
  "RSNY": "AZUL_(RSNY)",
  "SNDY": "AZUL_(SNDY)",
  "TELN": "GRIS_(TELN)",
  "PLTA": "CAFE_(PLTA)",
  "RMOT": "CAFE_(RMOT)",
  "SOTN": "CAFE_(SOTN)",
  "CHTA": "NEUTRO_(CHTA)",
  "LPTA": "NEUTRO_(LPTA)",
  "MPYT": "NEUTRO_(MPYT)",
  "MWPA": "CAFE_(MWPA)",
  "RMTA": "CAFE_(RMTA)",
  "TFPA": "CAFE_(TFPA)",
  "GPPI": "AZUL_(GPPI)",
  "AGPL": "GRIS_(AGPL)",
  "CPAG": "GRIS_(CPAG)",
  "FMIG": "GRIS_(FMIG)",
  "KPGY": "GRIS_(KPGY)",
  "FOPU": "NEUTRO_(FOPU)",
  "FSPE": "NEUTRO_(FSPE)",
  "IBPX": "NEUTRO_(IBPX)",
  "SPEX": "NEUTRO_(SPEX)",
  "CHRP": "NEUTRO_(CHRP)",
  "MFRP": "ROSADO_(MFRP)",
  "BSAR": "CAFE_(BSAR)",
  "CSGX": "VERDE_(CSGX)",
  "CYSE": "VERDE_(CYSE)",
  "SEGX": "VERDE_(SEGX)",
  "WWSE": "VERDE_(WWSE)",
  "JETN": "CAFE_(JETN)",
  "LPSE": "CAFE_(LPSE)",
  "SETR": "CAFE_(SETR)",
  "CCSX": "AMARILLO_(CCSX)",
  "CHSN": "NARANJO_(CHSN)",
  "RLSA": "AMARILLO_(RLSA)",
  "FSPI": "ROSADO_(FSPI)",
  "MESP": "ROSADO_(MESP)",
  "MYSP": "ROSADO_(MYSP)",
  "PLSP": "ROSADO_(PLSP)",
  "RISX": "ROSADO_(RISX)",
  "SFPX": "ROSADO_(SFPX)",
  "CSGY": "GRIS_(CSGY)",
  "FRGX": "GRIS_(FRGX)",
  "FTGY": "GRIS_(FTGY)",
  "LOSG": "GRIS_(LOSG)",
  "CPAS": "AZUL_(CPAS)",
  "DIBE": "AZUL_(DIBE)",
  "EWBE": "AZUL_(EWBE)",
  "GCBE": "AZUL_(GCBE)",
  "GMIS": "AZUL_(GMIS)",
  "GPBE": "AZUL_(GPBE)",
  "LOBL": "AZUL_(LOBL)",
  "NEPB": "AZUL_(NEPB)",
  "PSBB": "AZUL_(PSBB)",
  "RIST": "AZUL_(RIST)",
  "SHRE": "AZUL_(SHRE)",
  "SPLX": "ROSADO_(SPLX)",
  "STAX": "ROSADO_(STAX)",
  "CCSU": "ROJO_(CCSU)",
  "CHBD": "ROJO_(CHBD)",
  "CHSU": "ROJO_(CHSU)",
  "CPRD": "ROJO_(CPRD)",
  "FZRY": "AMARILLO_(FZRY)",
  "GPSU": "AMARILLO_(GPSU)",
  "HOSW": "AMARILLO_(HOSW)",
  "PASW": "AMARILLO_(PASW)",
  "COHG": "VERDE_(COHG)",
  "BFTI": "NARANJO_(BFTI)",
  "CSTI": "NARANJO_(CSTI)",
  "FPTI": "NARANJO_(FPTI)",
  "JHOT": "NARANJO_(JHOT)",
  "RITY": "NARANJO_(RITY)",
  "COHB": "AZUL_(COHB)",
  "CTIB": "AZUL_(CTIB)",
  "DOBB": "AZUL_(DOBB)",
  "HOTI": "AZUL_(HOTI)",
  "METI": "AZUL_(METI)",
  "OSTL": "AZUL_(OSTL)",
  "PBTI": "AZUL_(PBTI)",
  "RITB": "AZUL_(RITB)",
  "RIWT": "AZUL_(RIWT)",
  "CSTO": "NARANJO_(CSTO)",
  "FPTO": "NARANJO_(FPTO)",
  "OJPT": "NARANJO_(OJPT)",
  "OSBP": "NARANJO_(OSBP)",
  "WOSP": "NARANJO_(WOSP)",
  "TELX": "VERDE_(TELX)",
  "GPBR": "CAFE_(GPBR)",
  "PLUR": "AZUL_(PLUR)",
  "UMBB": "CAFE_(UMBB)",
  "LSUB": "AZUL_(LSUB)",
  "WWBE": "AZUL_(WWBE)",
  "BRWI": "BLANCO_(BRWI)",
  "DHWI": "BLANCO_(DHWI)",
  "PEWH": "BLANCO_(PEWH)",
  "ADGR": "VERDE_(ADGR)",
  "AKDB": "VERDE_(AKDB)",
  "ASDB": "VERDE_(ASDB)",
  "BRDA": "VERDE_(BRDA)",
  "IGDB": "VERDE_(IGDB)",
  "NODB": "VERDE_(NODB)",
  "NOLG": "VERDE_(NOLG)",
  "OCDB": "VERDE_(OCDB)",
  "OCKG": "VERDE_(OCKG)",
  "PEGR": "VERDE_(PEGR)",
  "QULG": "VERDE_(QULG)",
  "SKDA": "VERDE_(SKDA)",
  "SVBO": "VERDE_(SVBO)",
  "DAGX": "VERDE_(DAGX)",
  "DBBI": "CAFE_(DBBI)",
  "DUBR": "CAFE_(DUBR)",
  "JTDU": "CAFE_(JTDU)",
  "DUBX": "CAFE_(DUBX)",
  "FXRB": "ROJO_(FXRB)",
  "IFFR": "ROJO_(IFFR)",
  "PKFO": "ROJO_(PKFO)",
  "LOGF": "MORADO_(LOGF)",
  "ASHB": "CAFE_(ASHB)",
  "BFHE": "CAFE_(BFHE)",
  "FRUH": "CAFE_(FRUH)",
  "MTHE": "CAFE_(MTHE)",
  "DMOR": "NARANJO_(DMOR)",
  "FKOR": "NARANJO_(FKOR)",
  "PLOR": "NARANJO_(PLOR)",
  "ZSMO": "NARANJO_(ZSMO)",
  "HOPP": "ROSADO_(HOPP)",
  "ACGR": "VERDE_(ACGR)",
  "CAGN": "VERDE_(CAGN)",
  "CCNO": "VERDE_(CCNO)",
  "COLG": "VERDE_(COLG)",
  "GTNO": "VERDE_(GTNO)",
  "SEGT": "VERDE_(SEGT)",
  "SGWO": "VERDE_(SGWO)",
  "LOGN": "VERDE_(LOGN)",
  "BBNA": "AZUL_(BBNA)",
  "BBNY": "AZUL_(BBNY)",
  "CISN": "AZUL_(CISN)",
  "DRNE": "AZUL_(DRNE)",
  "FLEN": "AZUL_(FLEN)",
  "FNVY": "AZUL_(FNVY)",
  "HOPN": "AZUL_(HOPN)",
  "HUMN": "AZUL_(HUMN)",
  "LPNA": "AZUL_(LPNA)",
  "LWNE": "AZUL_(LWNE)",
  "NNWO": "AZUL_(NNWO)",
  "NSNY": "AZUL_(NSNY)",
  "TNVY": "AZUL_(TNVY)",
  "TUNE": "AZUL_(TUNE)",
  "TUNY": "AZUL_(TUNY)",
  "WBNA": "AZUL_(WBNA)",
  "WINN": "AZUL_(WINN)",
  "BSBE": "AZUL_(BSBE)",
  "SKBE": "AZUL_(SKBE)",
  "BECC": "AZUL_(BECC)",
  "DWBE": "AZUL_(DWBE)",
  "LKBE": "AZUL_(LKBE)",
  "PKAN": "AZUL_(PKAN)",
  "FZAL": "AZUL_(FZAL)",
  "RTAL": "AZUL_(RTAL)",
  "OTBX": "AZUL_(OTBX)",
  "SALX": "AZUL_(SALX)",
  "CNLX": "AZUL_(CNLX)",
  "BAKX": "NEGRO_(BAKX)",
  "BKTR": "NEGRO_(BKTR)",
  "EDBK": "NEGRO_(EDBK)",
  "PCBK": "NEGRO_(PCBK)",
  "TVBK": "NEGRO_(TVBK)",
  "GMIB": "NEGRO_(GMIB)",
  "GPIB": "NEGRO_(GPIB)",
  "INBX": "NEGRO_(INBX)",
  "PLST": "AZUL_(PLST)",
  "RRBE": "AZUL_(RRBE)",
  "BMSB": "AZUL_(BMSB)",
  "FISS": "AZUL_(FISS)",
  "GRBE": "AZUL_(GRBE)",
  "MOSM": "AZUL_(MOSM)",
  "SRIS": "AZUL_(SRIS)",
  "LIBX": "AZUL_(LIBX)",
  "SKYX": "AZUL_(SKYX)",
  "AUTB": "AZUL_(AUTB)",
  "LOKB": "AZUL_(LOKB)",
  "TIBE": "AZUL_(TIBE)",
  "TIBT": "AZUL_(TIBT)",
  "TIDX": "AZUL_(TIDX)",
  "LOGG": "VERDE_(LOGG)",
  "PUGR": "VERDE_(PUGR)",
  "BRID": "AZUL_(BRID)",
  "COLB": "AZUL_(COLB)",
  "IFDB": "AZUL_(IFDB)",

};

  // -----------------------------------
  // GLOBAL COLOR TRANSLATION FUNCTION
  // -----------------------------------
  window.translateColor = function(rawColor) {
    if (!rawColor) return rawColor;

    let cleanColor = rawColor
      .replace(/\(.+\)/, '')   // remove (anything)
      .replace(/-.+$/, '')     // remove -anything
      .replace(/\/.+$/, '')    // remove /anything
      .trim();

    return window.COLOR_TRANSLATIONS[cleanColor] || rawColor;
  };